var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSweetWrapper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 96,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v1h-1v-5h1zm59-3v-1h1v1zm0 2h-1v-1h1zM37 47h1v1h-1zm19 24h-1v-1h1zm8 4v1h-1v-1z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13v1h-1v-1zm53 10h1v1h-1zm-56 2h1v1h-1zm73 4v-1h1v1zm0 4h1v1h-1zm-2 24h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8v1h-1V8zm50 5v1h-1v-1zm5 7h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20v-1h1v1zm38 19h1v1h-1zM55 72h1v1h-1z",
    fill: "#fdffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7v1h-1V7zm34 60v1h-1v-1z",
    fill: "#767a70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h-1V9h1zm-4 21h-1v-1h1z",
    fill: "#7b7e6e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h1v1h-1zm23 30v-1h1v1z",
    fill: "#9ba09e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v-1h1v1zm9 43h-1v-1h1z",
    fill: "#6b705f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99 13v-1h1v1zm-3 52v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v1h-1v-1zm1 4v1h-1v-1z",
    fill: "#565749"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15v1h-1v-1zm19 30h1v1h-1z",
    fill: "#91938d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16v1h-1v-1zm6 46h1v1h-1z",
    fill: "#83887d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v1h-1v-1zm9 35h-1v-1h1z",
    fill: "#71766d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19h1v1h-1zm40 34h1v1h-1z",
    fill: "#8c8d8a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39 19v1h-1v-1zm2 34h-1v-1h1z",
    fill: "#666855"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1zm19 1h1v1h-1z",
    fill: "#d6d6c9",
    fillOpacity: 0.075
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1zm-4 0h1v1h-1z",
    fill: "#071127"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1zm22 38v-1h1v1z",
    fill: "#666b61"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27h1v1h-1zm52 66v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.016
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1zm36 50h1v1h-1z",
    fill: "#747769"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1zm38 51v-1h1v1z",
    fill: "#8f9694"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1zm-8 24h1v1h-1z",
    fill: "#a2a8a7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1zm0 4v-1h1v1z",
    fill: "#121d47"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1zm2 1v-1h1v1z",
    fill: "#cfd7d9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1zm2 11v1h-1v-1z",
    fill: "#2b2e31"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1zM67 74h-1v-1h1z",
    fill: "#adb7b3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1zm21 16v-1h1v1z",
    fill: "#828b8b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1zm-11 4v1h-1v-1z",
    fill: "#afb6b6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1zm-4 30h-1v-1h1z",
    fill: "#566057"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1zm40 37v1h-1v-1z",
    fill: "#625f4c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1zm29 17v1h-1v-1z",
    fill: "#cbd5d7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1zm21 6v1h-1v-1z",
    fill: "#66707a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1zm4 12v-1h1v1z",
    fill: "#4f585e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1zm6 12h1v1h-1z",
    fill: "#5e625d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1zm4 29v1h-1v-1z",
    fill: "#848683"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1zm4 2v1h-1v-1z",
    fill: "#929693"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1zm12 4h-1v-1h1z",
    fill: "#303738"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1zm2 6v-1h1v1z",
    fill: "#9b9c94"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1zm-18 2h-1v-1h1z",
    fill: "#a4a9a3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1zm16 6v1h-1v-1z",
    fill: "#aaaab2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1zm26 26h1v1h-1z",
    fill: "#b7bbbf"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1zm11 18h1v1h-1z",
    fill: "#787d74"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1zm11 4v1h-1v-1z",
    fill: "#bfcdcb"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1zm1 4h-1v-1h1z",
    fill: "#d8e3e0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4V3h1v1z",
    fill: "#8fa181",
    fillOpacity: 0.224
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M40 3v1h-1V3z",
    fill: "#abb29d",
    fillOpacity: 0.757
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3v1h-1V3z",
    fill: "#bdc2b1",
    fillOpacity: 0.659
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3v1h-1V3z",
    fill: "#c9cfc3",
    fillOpacity: 0.337
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M43 3v1h-1V3z",
    fill: "#d4d4e9",
    fillOpacity: 0.047
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4v1h-1V4z",
    fill: "#e0e7d0",
    fillOpacity: 0.129
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5V4h1v1z",
    fill: "#818880",
    fillOpacity: 0.855
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h-1V4h1z",
    fill: "#6b6e69"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41 5h-1V4h1z",
    fill: "#7e836f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41 4h1v1h-1z",
    fill: "#9fa68c"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5h-1V4h1z",
    fill: "#b9c0b0",
    fillOpacity: 0.82
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5V4h1v1z",
    fill: "#e2eaec",
    fillOpacity: 0.498
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4v1h-1V4z",
    fill: "#f0f7f7",
    fillOpacity: 0.137
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M37 5v1h-1V5z",
    fill: "#839a7b",
    fillOpacity: 0.129
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37 6V5h1v1z",
    fill: "#5e6c52",
    fillOpacity: 0.812
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5h1v1h-1z",
    fill: "#6f7769"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39 5h1v1h-1z",
    fill: "#787f7b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h1v1h-1z",
    fill: "#6e7270"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M41 6V5h1v1z",
    fill: "#5e635c"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42 6V5h1v1z",
    fill: "#879385"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M43 6V5h1v1z",
    fill: "#e8f8e3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5v1h-1V5z",
    fill: "#9fb392",
    fillOpacity: 0.882
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M46 5v1h-1V5z",
    fill: "#a3b2a8",
    fillOpacity: 0.208
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36 7h-1V6h1z",
    fill: "#a2b18b",
    fillOpacity: 0.129
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36 7V6h1v1z",
    fill: "#899287",
    fillOpacity: 0.827
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38 6v1h-1V6z",
    fill: "#767a79"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M39 6v1h-1V6z",
    fill: "#585b5d"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M39 7V6h1v1z",
    fill: "#394038"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41 7h-1V6h1z",
    fill: "#464a41"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7h-1V6h1z",
    fill: "#4f5750"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7V6h1v1z",
    fill: "#5a675b"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7h-1V6h1z",
    fill: "#728168"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h-1V6h1z",
    fill: "#7d8c81"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M46 7h-1V6h1z",
    fill: "#8c9b92",
    fillOpacity: 0.776
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7h-1V6h1z",
    fill: "#cfc",
    fillOpacity: 0.02
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M34 7h1v1h-1z",
    fill: "#9ab69a",
    fillOpacity: 0.11
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8h-1V7h1z",
    fill: "#555c44",
    fillOpacity: 0.8
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37 7v1h-1V7z",
    fill: "#3b3e38"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7v1h-1V7z",
    fill: "#485149"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7h1v1h-1z",
    fill: "#697065"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8h-1V7h1z",
    fill: "#4e5345"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7h1v1h-1z",
    fill: "#3d3a36"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8V7h1v1z",
    fill: "#484c41"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42 8V7h1v1z",
    fill: "#4b5548"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h-1V7h1z",
    fill: "#929c94"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h1v1h-1z",
    fill: "#8b968f",
    fillOpacity: 0.992
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7v1h-1V7z",
    fill: "#a6aaa6",
    fillOpacity: 0.282
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9V8h1v1z",
    fill: "#caceb4",
    fillOpacity: 0.227
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9h-1V8h1z",
    fill: "#91997a",
    fillOpacity: 0.816
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8v1h-1V8z",
    fill: "#5b5e48"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8h1v1h-1z",
    fill: "#5c564a"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M38 8v1h-1V8z",
    fill: "#636148"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9h-1V8h1z",
    fill: "#5c6043"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8v1h-1V8z",
    fill: "#424838"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8v1h-1V8z",
    fill: "#555348"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8h1v1h-1z",
    fill: "#77786c"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8v1h-1V8z",
    fill: "#71766b"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8h1v1h-1z",
    fill: "#757967"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h-1V8h1z",
    fill: "#889384"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h1v1h-1z",
    fill: "#8b9992"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M46 8h1v1h-1z",
    fill: "#99a4a2",
    fillOpacity: 0.706
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10V9h1v1z",
    fill: "#bcc3a7",
    fillOpacity: 0.286
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10h-1V9h1z",
    fill: "#959879",
    fillOpacity: 0.937
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9v1h-1V9z",
    fill: "#949177"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10V9h1v1z",
    fill: "#717155"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9v1h-1V9z",
    fill: "#6a6a4e"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M38 10h-1V9h1z",
    fill: "#6d6951"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9v1h-1V9z",
    fill: "#6a6a55"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10h-1V9h1z",
    fill: "#626251"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h-1V9h1z",
    fill: "#726d5f"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9h1v1h-1z",
    fill: "#7d7b68"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M43 9h1v1h-1z",
    fill: "#81887f"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10V9h1v1z",
    fill: "#7b8072"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47 9v1h-1V9z",
    fill: "#a1aba4",
    fillOpacity: 0.969
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10V9h1v1z",
    fill: "#a8b3a8",
    fillOpacity: 0.173
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11h-1v-1h1z",
    fill: "#ccc5b2",
    fillOpacity: 0.157
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10h1v1h-1z",
    fill: "#a7a48e",
    fillOpacity: 0.929
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10v1h-1v-1z",
    fill: "#707059"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11v-1h1v1z",
    fill: "#696d5c"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10v1h-1v-1z",
    fill: "#697263"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M36 11v-1h1v1z",
    fill: "#616c5a"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M37 11v-1h1v1z",
    fill: "#525950"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v-1h1v1z",
    fill: "#575b4f"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10h1v1h-1z",
    fill: "#5e6357"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10v1h-1v-1z",
    fill: "#73746e"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h1v1h-1z",
    fill: "#6a7162"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10v1h-1v-1z",
    fill: "#646c57"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h1v1h-1z",
    fill: "#6b7166"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M45 11h-1v-1h1z",
    fill: "#686855"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10v1h-1v-1z",
    fill: "#817e6a"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11v-1h1v1z",
    fill: "#909586"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10h1v1h-1z",
    fill: "#939991",
    fillOpacity: 0.529
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v-1h1v1z",
    fill: "#e7ffff",
    fillOpacity: 0.043
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11h1v1h-1z",
    fill: "#bcc0b5",
    fillOpacity: 0.706
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M33 11v1h-1v-1z",
    fill: "#9ea18e"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12h-1v-1h1z",
    fill: "#838585"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12h-1v-1h1z",
    fill: "#85898e"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v-1h1v1z",
    fill: "#9a9fa9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12v-1h1v1z",
    fill: "#b0b5b9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v1h-1v-1z",
    fill: "#858f93"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12h-1v-1h1z",
    fill: "#6a7474"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h-1v-1h1z",
    fill: "#444e49"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12v-1h1v1z",
    fill: "#7f8382"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M41 11h1v1h-1z",
    fill: "#878e88"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11h1v1h-1z",
    fill: "#747762"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12h-1v-1h1z",
    fill: "#9a9a93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M44 11h1v1h-1z",
    fill: "#959a8a"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12h-1v-1h1z",
    fill: "#787a6a"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11v1h-1v-1z",
    fill: "#7d7e72"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12v-1h1v1z",
    fill: "#8d928b",
    fillOpacity: 0.918
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h-1v-1h1z",
    fill: "#acb4b4",
    fillOpacity: 0.122
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v1h-1v-1z",
    fill: "#a2a892",
    fillOpacity: 0.184
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12h1v1h-1z",
    fill: "#c1c9bd",
    fillOpacity: 0.749
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13v-1h1v1z",
    fill: "#b2bdb3"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12h1v1h-1z",
    fill: "#6b786e"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h-1v-1h1z",
    fill: "#848883"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v1h-1v-1z",
    fill: "#7a8271"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h-1v-1h1z",
    fill: "#7d877f"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v1h-1v-1z",
    fill: "#97a092"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13v-1h1v1z",
    fill: "#73806f"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M38 13v-1h1v1z",
    fill: "#707d70"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13v-1h1v1z",
    fill: "#5d6159"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1z",
    fill: "#5f605b"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h1v1z",
    fill: "#858782"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M42 12h1v1h-1z",
    fill: "#828275"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h-1v-1h1z",
    fill: "#a9aca9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13v-1h1v1z",
    fill: "#a4b09b"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12v1h-1v-1z",
    fill: "#747c67"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13h-1v-1h1z",
    fill: "#8c9586"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M49 13h-1v-1h1z",
    fill: "#939c94",
    fillOpacity: 0.537
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M101 13h-1v-1h1z",
    fill: "#b4b284",
    fillOpacity: 0.416
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M101 13v-1h1v1z",
    fill: "#d3ce99",
    fillOpacity: 0.553
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M102 13v-1h1v1z",
    fill: "#ffffd0",
    fillOpacity: 0.043
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14h-1v-1h1z",
    fill: "#7a7e63",
    fillOpacity: 0.761
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13h1v1h-1z",
    fill: "#8b8e7a"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13h1v1h-1z",
    fill: "#919696"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h-1v-1h1z",
    fill: "#d1d8dc"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14v-1h1v1z",
    fill: "#78816e"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h1v1h-1z",
    fill: "#575a4a"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13v1h-1v-1z",
    fill: "#4e5546"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h1v1h-1z",
    fill: "#3a4233"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13h1v1h-1z",
    fill: "#333a32"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14v-1h1v1z",
    fill: "#484c44"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v1h-1v-1z",
    fill: "#595d51"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13h1v1h-1z",
    fill: "#89918c"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h-1v-1h1z",
    fill: "#929690"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14v-1h1v1z",
    fill: "#eaf1ef"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h1v1h-1z",
    fill: "#becbb2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v1h-1v-1z",
    fill: "#585d4a"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13h1v1h-1z",
    fill: "#6c6a5d"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v-1h1v1z",
    fill: "#717664"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14v-1h1v1z",
    fill: "#889488",
    fillOpacity: 0.914
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14h-1v-1h1z",
    fill: "#b3bcbc",
    fillOpacity: 0.106
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M98 14v-1h1v1z",
    fill: "#b6ad8b",
    fillOpacity: 0.329
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M100 14h-1v-1h1z",
    fill: "#b7a677",
    fillOpacity: 0.765
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M101 14h-1v-1h1z",
    fill: "#aca26a"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M102 14h-1v-1h1z",
    fill: "#e8db9c"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M103 14h-1v-1h1z",
    fill: "#f0e6c2",
    fillOpacity: 0.412
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15v-1h1v1z",
    fill: "#687758",
    fillOpacity: 0.192
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14h1v1h-1z",
    fill: "#5b6150",
    fillOpacity: 0.965
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15v-1h1v1z",
    fill: "#6d6e5d"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14v1h-1v-1z",
    fill: "#a8aaaf"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v-1h1v1z",
    fill: "#fefffd"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h1v1h-1z",
    fill: "#899276"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15h-1v-1h1z",
    fill: "#64685c"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1z",
    fill: "#707669"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15h-1v-1h1z",
    fill: "#838273"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15v-1h1v1z",
    fill: "#6a675d"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14v1h-1v-1z",
    fill: "#404137"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1z",
    fill: "#3e3e31"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h-1v-1h1z",
    fill: "#5f6053"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14v1h-1v-1z",
    fill: "#818a7d"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1z",
    fill: "#8d9589"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h1v1h-1z",
    fill: "#c7d5c8"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15h-1v-1h1z",
    fill: "#99a389"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15h-1v-1h1z",
    fill: "#5b5e4c"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15h-1v-1h1z",
    fill: "#8a8c85"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15h-1v-1h1z",
    fill: "#71766e"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15h-1v-1h1z",
    fill: "#878e84"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-1v-1z",
    fill: "#adb5b1",
    fillOpacity: 0.49
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14v1h-1v-1z",
    fill: "#acac78",
    fillOpacity: 0.267
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14h1v1h-1z",
    fill: "#e3d79a",
    fillOpacity: 0.51
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v1h-1v-1z",
    fill: "#c4b67c",
    fillOpacity: 0.596
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M91 15h-1v-1h1z",
    fill: "#c3be81",
    fillOpacity: 0.541
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M91 14h1v1h-1z",
    fill: "#fcfce1",
    fillOpacity: 0.408
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M92 14h1v1h-1z",
    fill: "#fbfbff",
    fillOpacity: 0.286
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M94 14v1h-1v-1z",
    fill: "#f3f3e8",
    fillOpacity: 0.18
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M95 14v1h-1v-1z",
    fill: "#e1e8ca",
    fillOpacity: 0.133
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M95 15v-1h1v1z",
    fill: "#d5debd",
    fillOpacity: 0.122
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15h-1v-1h1z",
    fill: "#e0eacc",
    fillOpacity: 0.098
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15v-1h1v1z",
    fill: "#d8cbb1",
    fillOpacity: 0.388
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15h-1v-1h1z",
    fill: "#baa075"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15v-1h1v1z",
    fill: "#b2965e"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M100 14h1v1h-1z",
    fill: "#988752"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M102 14v1h-1v-1z",
    fill: "#dfcb98"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M103 15h-1v-1h1z",
    fill: "#ebdeb2",
    fillOpacity: 0.82
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M103 14h1v1h-1z",
    fill: "#e2e2e2",
    fillOpacity: 0.035
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h-1v-1h1z",
    fill: "#dfe5eb",
    fillOpacity: 0.157
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16v-1h1v1z",
    fill: "#d0dfd8",
    fillOpacity: 0.282
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h1v1h-1z",
    fill: "#b3bdae",
    fillOpacity: 0.396
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15h1v1h-1z",
    fill: "#7b8478",
    fillOpacity: 0.824
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16v-1h1v1z",
    fill: "#676d77"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15h1v1h-1z",
    fill: "#7e8376"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v1h-1v-1z",
    fill: "#c7cccd"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-1z",
    fill: "#b0bbac"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16v-1h1v1z",
    fill: "#67695f"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15v1h-1v-1z",
    fill: "#5d5f53"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h-1z",
    fill: "#727369"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16v-1h1v1z",
    fill: "#8c8f80"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1z",
    fill: "#5e5e4d"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1z",
    fill: "#545146"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15v1h-1v-1z",
    fill: "#656a5d"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h1v1h-1z",
    fill: "#737e74"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h-1v-1h1z",
    fill: "#81847e"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16v-1h1v1z",
    fill: "#878d83"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16h-1v-1h1z",
    fill: "#7e8373"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15v1h-1v-1z",
    fill: "#797a67"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M47 16h-1v-1h1z",
    fill: "#6d725b"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16h-1v-1h1z",
    fill: "#6f786e"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16h-1v-1h1z",
    fill: "#96998c",
    fillOpacity: 0.867
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-1z",
    fill: "#bfcfbf",
    fillOpacity: 0.063
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M85 15h1v1h-1z",
    fill: "#ccbfa5",
    fillOpacity: 0.157
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M86 16v-1h1v1z",
    fill: "#a99f6e",
    fillOpacity: 0.761
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#b8a265"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M88 15h1v1h-1z",
    fill: "#c6a258"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M90 16h-1v-1h1z",
    fill: "#c9ab6b"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M90 15h1v1h-1z",
    fill: "#eee5b0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M91 16v-1h1v1z",
    fill: "#ffffe5"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h-1v-1h1z",
    fill: "#e5e0bb",
    fillOpacity: 0.98
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M94 15h1v1h-1z",
    fill: "#9e935b",
    fillOpacity: 0.949
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16h-1v-1h1z",
    fill: "#8e8452",
    fillOpacity: 0.941
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v-1h1v1z",
    fill: "#898554",
    fillOpacity: 0.922
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M98 15v1h-1v-1z",
    fill: "#a59762",
    fillOpacity: 0.98
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M99 16h-1v-1h1z",
    fill: "#b79e63"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15h1v1h-1z",
    fill: "#9d8653"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M101 15v1h-1v-1z",
    fill: "#9d9057"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M101 16v-1h1v1z",
    fill: "#e7d398"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M103 15v1h-1v-1z",
    fill: "#ecdca7"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M103 16v-1h1v1z",
    fill: "#e8e2bf",
    fillOpacity: 0.349
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16h1v1h-1z",
    fill: "#cbd7d4",
    fillOpacity: 0.714
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h1v1h-1z",
    fill: "#b4c6b9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h-1v-1h1z",
    fill: "#869485"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v-1h1v1z",
    fill: "#868c8c"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16h1v1h-1z",
    fill: "#b7c3cb"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16v1h-1v-1z",
    fill: "#b2beb4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h-1v-1h1z",
    fill: "#d6dada"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17v-1h1v1z",
    fill: "#e2eee8"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16h1v1h-1z",
    fill: "#c7d5cc"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17v-1h1v1z",
    fill: "#5e6b5b"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h1v1h-1z",
    fill: "#4d504d"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16v1h-1v-1z",
    fill: "#8d928f"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16h1v1h-1z",
    fill: "#8b8e89"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17v-1h1v1z",
    fill: "#807f7c"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h1v1z",
    fill: "#60655c"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17h-1v-1h1z",
    fill: "#626e5f"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16h1v1h-1z",
    fill: "#7d8479"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h1v1h-1z",
    fill: "#85877e"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17v-1h1v1z",
    fill: "#747767"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h-1v-1h1z",
    fill: "#817d58"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M48 17h-1v-1h1z",
    fill: "#86896a"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17h-1v-1h1z",
    fill: "#767b6d"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16v1h-1v-1z",
    fill: "#7c8775"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1z",
    fill: "#9ba59d",
    fillOpacity: 0.412
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17h-1v-1h1z",
    fill: "#d7cbaf",
    fillOpacity: 0.251
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1z",
    fill: "#b7a672",
    fillOpacity: 0.894
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1z",
    fill: "#beb366"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1z",
    fill: "#e0d08a"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M89 17h-1v-1h1z",
    fill: "#e6d9aa"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1z",
    fill: "#fefbe8"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17v-1h1v1z",
    fill: "#fffffb"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M91 17v-1h1v1z",
    fill: "#fefef9"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16h1v1h-1z",
    fill: "#ffffe8"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M93 16h1v1h-1z",
    fill: "#cdbb7c"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h1v1h-1z",
    fill: "#7e672e"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v1h-1v-1z",
    fill: "#7b6338"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h-1v-1h1z",
    fill: "#74602f"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17v-1h1v1z",
    fill: "#8a743c"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M99 16v1h-1v-1z",
    fill: "#a58d50"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M100 16v1h-1v-1z",
    fill: "#8e7b48"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M100 16h1v1h-1z",
    fill: "#aaa065"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M101 16h1v1h-1z",
    fill: "#ebd99e"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M103 16v1h-1v-1z",
    fill: "#e5d4a5"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M103 16h1v1h-1z",
    fill: "#e5dec0",
    fillOpacity: 0.435
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18v-1h1v1z",
    fill: "#d6d6ea",
    fillOpacity: 0.098
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h-1v-1h1z",
    fill: "#c5d0ca",
    fillOpacity: 0.898
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18v-1h1v1z",
    fill: "#758374"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h1v1h-1z",
    fill: "#c4cac9"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18v-1h1v1z",
    fill: "#b3c7b9"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18v-1h1v1z",
    fill: "#97a49d"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17v1h-1v-1z",
    fill: "#dfe1e1"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1z",
    fill: "#f5fbf6"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18v-1h1v1z",
    fill: "#e5f2e8"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17h1v1h-1z",
    fill: "#b6c6be"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18v-1h1v1z",
    fill: "#868892"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18h-1v-1h1z",
    fill: "#b0b2b4"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1z",
    fill: "#969e93"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17h1v1h-1z",
    fill: "#676f60"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17v1h-1v-1z",
    fill: "#5b6050"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18h-1v-1h1z",
    fill: "#6b7667"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17v1h-1v-1z",
    fill: "#798374"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17h1v1h-1z",
    fill: "#818c7f"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17h1v1h-1z",
    fill: "#90948d"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18v-1h1v1z",
    fill: "#7a7967"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h1v1h-1z",
    fill: "#7e7d5b"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h-1v-1h1z",
    fill: "#7c7c65"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18h-1v-1h1z",
    fill: "#6a7462"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17v1h-1v-1z",
    fill: "#909a8c",
    fillOpacity: 0.867
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17h1v1h-1z",
    fill: "#dceadc",
    fillOpacity: 0.145
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1z",
    fill: "#e1d5b7",
    fillOpacity: 0.169
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v1h-1v-1z",
    fill: "#d8c18c",
    fillOpacity: 0.91
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h-1v-1h1z",
    fill: "#bba45d"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1z",
    fill: "#e9e28b"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1z",
    fill: "#fefec7"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M88 17h1v1h-1z",
    fill: "#ffffd6"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1z",
    fill: "#feffce"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18h-1v-1h1z",
    fill: "#fffef3"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18v-1h1v1z",
    fill: "#f9f2cc"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M94 17v1h-1v-1z",
    fill: "#bf9e5a"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M95 18h-1v-1h1z",
    fill: "#836433"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h-1v-1h1z",
    fill: "#745c29"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M96 17h1v1h-1z",
    fill: "#6d5c24"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h1v1h-1z",
    fill: "#917944"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M99 17v1h-1v-1z",
    fill: "#8c703a"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M99 18v-1h1v1z",
    fill: "#867540"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M100 17h1v1h-1z",
    fill: "#afa764"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v-1h1v1z",
    fill: "#fbf0b3"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M102 17h1v1h-1z",
    fill: "#e9ddb5",
    fillOpacity: 0.827
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18v-1h1v1z",
    fill: "#ddc",
    fillOpacity: 0.059
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19v-1h1v1z",
    fill: "#663",
    fillOpacity: 0.02
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19h-1v-1h1z",
    fill: "#a8aba8",
    fillOpacity: 0.667
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18v1h-1v-1z",
    fill: "#c7d4cd"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h1v1h-1z",
    fill: "#616c5e"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19h-1v-1h1z",
    fill: "#7a7c78"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19h-1v-1h1z",
    fill: "#acb8b1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18h1v1h-1z",
    fill: "#788784"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19h-1v-1h1z",
    fill: "#868b87"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18h1v1h-1z",
    fill: "#d7dcd8"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v-1h1v1z",
    fill: "#fbfffc"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19h-1v-1h1z",
    fill: "#d0dbd3"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-1v-1h1z",
    fill: "#e2e9e6"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19v-1h1v1z",
    fill: "#e5e8ea"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18v1h-1v-1z",
    fill: "#a0a697"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v-1h1v1z",
    fill: "#6b6e59"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18v1h-1v-1z",
    fill: "#545c48"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v-1h1v1z",
    fill: "#565b4a"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19v-1h1v1z",
    fill: "#5d604f"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19h-1v-1h1z",
    fill: "#646b56"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M44 18v1h-1v-1z",
    fill: "#6f7a6a"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19h-1v-1h1z",
    fill: "#868d83"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19v-1h1v1z",
    fill: "#939891"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M47 18v1h-1v-1z",
    fill: "#8a8f88"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v-1h1v1z",
    fill: "#7e7e6b"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19v-1h1v1z",
    fill: "#6e7155"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h1v1h-1z",
    fill: "#646d56"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M51 19h-1v-1h1z",
    fill: "#7a8377"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19h-1v-1h1z",
    fill: "#c5cfc7",
    fillOpacity: 0.89
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19v-1h1v1z",
    fill: "#d9e5d9",
    fillOpacity: 0.396
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.035
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#cad3ca",
    fillOpacity: 0.114
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#d1d6d1",
    fillOpacity: 0.196
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#cfd9cc",
    fillOpacity: 0.294
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1z",
    fill: "#7e9aa9",
    fillOpacity: 0.42
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#5c7c99",
    fillOpacity: 0.561
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#97a6bb",
    fillOpacity: 0.588
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#c6d0d2",
    fillOpacity: 0.514
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#8aa5a5",
    fillOpacity: 0.369
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#90af9c",
    fillOpacity: 0.325
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#9dbaae",
    fillOpacity: 0.247
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#b2cccc",
    fillOpacity: 0.039
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18v1h-1v-1z",
    fill: "#decda9",
    fillOpacity: 0.608
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v1h-1v-1z",
    fill: "#e5c991"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1z",
    fill: "#dbbc6c"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h1v1h-1z",
    fill: "#fef08d"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M88 19h-1v-1h1z",
    fill: "#fefdc5"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M88 18h1v1h-1z",
    fill: "#f9f2a8"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M89 18h1v1h-1z",
    fill: "#fffedd"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18v1h-1v-1z",
    fill: "#fffffc"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19v-1h1v1z",
    fill: "#ffffe9"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M93 18v1h-1v-1z",
    fill: "#e5d697"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M93 19v-1h1v1z",
    fill: "#b89645"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M94 18h1v1h-1z",
    fill: "#8b6b30"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18v1h-1v-1z",
    fill: "#6d5622"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h1v1h-1z",
    fill: "#775f25"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M98 18v1h-1v-1z",
    fill: "#8f7639"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M98 19v-1h1v1z",
    fill: "#836b3b"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19h-1v-1h1z",
    fill: "#7a6a3a"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v1h-1v-1z",
    fill: "#c1b675"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18h1v1h-1z",
    fill: "#f3e6b2",
    fillOpacity: 0.992
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18v1h-1v-1z",
    fill: "#e7e1bd",
    fillOpacity: 0.333
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20h-1v-1h1z",
    fill: "#555",
    fillOpacity: 0.024
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20v-1h1v1z",
    fill: "#8c938c",
    fillOpacity: 0.816
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20v-1h1v1z",
    fill: "#b6c3b7"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19h1v1h-1z",
    fill: "#737c68"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19v1h-1v-1z",
    fill: "#969fa0"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19v1h-1v-1z",
    fill: "#788276"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20v-1h1v1z",
    fill: "#7b7e6f"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v1h-1v-1z",
    fill: "#c5cbcb"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20v-1h1v1z",
    fill: "#f8fff9"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19v1h-1v-1z",
    fill: "#e4ede4"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-1h1v1z",
    fill: "#ccd6cb"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v1h-1v-1z",
    fill: "#c7cebd"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v1h-1v-1z",
    fill: "#595e4c"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19h1v1h-1z",
    fill: "#545c4c"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v-1h1v1z",
    fill: "#66695b"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20h-1v-1h1z",
    fill: "#5c5e4f"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19v1h-1v-1z",
    fill: "#64695e"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19h1v1h-1z",
    fill: "#7f8277"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20v-1h1v1z",
    fill: "#8d968a"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v1h-1v-1z",
    fill: "#959892"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M48 20h-1v-1h1z",
    fill: "#8d8c82"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19v1h-1v-1z",
    fill: "#7a7b60"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v-1h1v1z",
    fill: "#60664c"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20v-1h1v1z",
    fill: "#919892"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20v-1h1v1z",
    fill: "#cfd4d1"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20v-1h1v1z",
    fill: "#c9d5ca",
    fillOpacity: 0.863
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19v1h-1v-1z",
    fill: "#dde9dd",
    fillOpacity: 0.235
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19h1v1h-1z",
    fill: "#b5c2ae",
    fillOpacity: 0.447
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#a5b2a0",
    fillOpacity: 0.678
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#b0b9b6",
    fillOpacity: 0.839
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#babfbd",
    fillOpacity: 0.933
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#acb3ac",
    fillOpacity: 0.988
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#88968e"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#416083"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#244a88"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#4c628a"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#a6b5b6"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#728789"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#78898f"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#b2c0c9"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#d2e2e8",
    fillOpacity: 0.318
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1z",
    fill: "#deca9e",
    fillOpacity: 0.894
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M85 19v1h-1v-1z",
    fill: "#e0c88b"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M86 20h-1v-1h1z",
    fill: "#edcb64"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M86 19h1v1h-1z",
    fill: "#faf293"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h-1v-1h1z",
    fill: "#fdfbd6"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M89 20h-1v-1h1z",
    fill: "#f8f1b7"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M90 19v1h-1v-1z",
    fill: "#fdfedf"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20v-1h1v1z",
    fill: "#f9fcca"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19h1v1h-1z",
    fill: "#fdfcbc"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M92 19h1v1h-1z",
    fill: "#c6ac5c"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M94 19v1h-1v-1z",
    fill: "#a88334"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M95 19v1h-1v-1z",
    fill: "#896d28"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h-1v-1h1z",
    fill: "#6d5521"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M96 19h1v1h-1z",
    fill: "#785e2a"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M97 20v-1h1v1z",
    fill: "#8c7030"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20h-1v-1h1z",
    fill: "#ae8e4c"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19v1h-1v-1z",
    fill: "#a48d51"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20h-1v-1h1z",
    fill: "#d3c288"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M101 19h1v1h-1z",
    fill: "#eee3bc",
    fillOpacity: 0.659
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21v-1h1v1z",
    fill: "#9b9fa5",
    fillOpacity: 0.482
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20v1h-1v-1z",
    fill: "#b4c0b8"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21h-1v-1h1z",
    fill: "#7f846c"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20h1v1h-1z",
    fill: "#8f908b"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20h1v1h-1z",
    fill: "#cfd8d8"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h-1v-1h1z",
    fill: "#919882"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20v1h-1v-1z",
    fill: "#74725f"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21v-1h1v1z",
    fill: "#ced1d2"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20h1v1h-1z",
    fill: "#f5fbf2"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20v1h-1v-1z",
    fill: "#e5f1e3"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21h-1v-1h1z",
    fill: "#f1fdf2"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20h1v1h-1z",
    fill: "#b5c3af"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20h1v1h-1z",
    fill: "#e7f1e9"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21h-1v-1h1z",
    fill: "#c6ccbc"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20h1v1h-1z",
    fill: "#7a7969"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20v1h-1v-1z",
    fill: "#5e5d4a"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v1h-1v-1z",
    fill: "#58614e"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20v1h-1v-1z",
    fill: "#606556"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20v1h-1v-1z",
    fill: "#808174"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v1h-1v-1z",
    fill: "#97a096"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21h-1v-1h1z",
    fill: "#6c796c"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20v1h-1v-1z",
    fill: "#818a82"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20h1v1h-1z",
    fill: "#a7a9a9"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M47 20h1v1h-1z",
    fill: "#b4b6b8"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v1h-1v-1z",
    fill: "#8e8f80"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20h1v1h-1z",
    fill: "#656750"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20h1v1h-1z",
    fill: "#79806e"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h-1v-1h1z",
    fill: "#7e8974"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v1h-1v-1z",
    fill: "#c9d5c7",
    fillOpacity: 0.992
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M53 21v-1h1v1z",
    fill: "#d6e1d8",
    fillOpacity: 0.984
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v1h-1v-1z",
    fill: "#97a093"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#939994"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#bac0c6"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#c4c9ce"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#9fa69e"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#6d7e83"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#2d426f"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#142855"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#182543"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#415365"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#828aa1"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#aaafd2"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#c7d1e3"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#d5e4e6",
    fillOpacity: 0.412
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#e0cfbe",
    fillOpacity: 0.231
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#ddca9d",
    fillOpacity: 0.996
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#dec287"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M85 20h1v1h-1z",
    fill: "#edc565"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21v-1h1v1z",
    fill: "#f1e88b"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M88 21h-1v-1h1z",
    fill: "#fefede"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h1v1h-1z",
    fill: "#f8f7bd"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21h-1v-1h1z",
    fill: "#f3f4ab"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20h1v1h-1z",
    fill: "#ebe89c"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h-1v-1h1z",
    fill: "#d8c67c"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21v-1h1v1z",
    fill: "#be9c54"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M94 20v1h-1v-1z",
    fill: "#99762b"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M95 21h-1v-1h1z",
    fill: "#755a21"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M95 20h1v1h-1z",
    fill: "#6b531f"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h1v1h-1z",
    fill: "#6e5826"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M98 20v1h-1v-1z",
    fill: "#84682e"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20v1h-1v-1z",
    fill: "#ab8746"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M99 21v-1h1v1z",
    fill: "#ac985b"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20v1h-1v-1z",
    fill: "#d4c892"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M101 21v-1h1v1z",
    fill: "#e9e5be",
    fillOpacity: 0.278
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21h1v1h-1z",
    fill: "#c2cbcf",
    fillOpacity: 0.231
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21h1v1h-1z",
    fill: "#b0bdb1",
    fillOpacity: 0.992
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21h1v1h-1z",
    fill: "#81857c"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v-1h1v1z",
    fill: "#9ca19b"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22h-1v-1h1z",
    fill: "#f4fcfb"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h-1v-1h1z",
    fill: "#dadfd2"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h1v1h-1z",
    fill: "#7d8271"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21h1v1h-1z",
    fill: "#c0c7c0"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v1h-1v-1z",
    fill: "#deeee3"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v-1h1v1z",
    fill: "#b3c0ae"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21v1h-1v-1z",
    fill: "#f1fcf2"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22h-1v-1h1z",
    fill: "#acb9a1"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21h1v1h-1z",
    fill: "#d6ddd6"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21v1h-1v-1z",
    fill: "#b4bcad"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22v-1h1v1z",
    fill: "#959490"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22v-1h1v1z",
    fill: "#9c998b"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22v-1h1v1z",
    fill: "#6f6e5d"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21h1v1h-1z",
    fill: "#67665b"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21h1v1h-1z",
    fill: "#817f74"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22v-1h1v1z",
    fill: "#929991"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21h1v1h-1z",
    fill: "#829088"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22v-1h1v1z",
    fill: "#959798"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21v1h-1v-1z",
    fill: "#b9bdbe"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22v-1h1v1z",
    fill: "#d7e1e2"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21v1h-1v-1z",
    fill: "#bcc2b8"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M50 21v1h-1v-1z",
    fill: "#656858"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21v1h-1v-1z",
    fill: "#5c5f4b"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21v1h-1v-1z",
    fill: "#575d48"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#7f8b75"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#cad6d5"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#acb9ba"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#a7adab"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#bcc2be"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#b0b8b2"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#767e76"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#445262"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#161c3c"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#0d1628"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#191b3f"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#4a5c8f"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#a1b0d1"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#bdc8dd"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#c7d3ea"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#d1dfe8",
    fillOpacity: 0.443
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#d8ceb9",
    fillOpacity: 0.286
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v1h-1v-1z",
    fill: "#e0caa3"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21v1h-1v-1z",
    fill: "#dfbf89"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22v-1h1v1z",
    fill: "#d9a94a"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21h1v1h-1z",
    fill: "#f9e794"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#fffee5"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#f7f9c4"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21v1h-1v-1z",
    fill: "#e2d792"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M91 22h-1v-1h1z",
    fill: "#bda855"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M91 21h1v1h-1z",
    fill: "#d4b96e"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h1v1h-1z",
    fill: "#d9b979"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M94 22h-1v-1h1z",
    fill: "#a77e38"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M94 21h1v1h-1z",
    fill: "#6d501c"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M96 22h-1v-1h1z",
    fill: "#634c1c"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M97 21v1h-1v-1z",
    fill: "#6c5626"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22v-1h1v1z",
    fill: "#7d642b"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22h-1v-1h1z",
    fill: "#876f3a"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M99 21h1v1h-1z",
    fill: "#b7a769"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M101 22h-1v-1h1z",
    fill: "#e3ddab",
    fillOpacity: 0.886
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23h-1v-1h1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23v-1h1v1z",
    fill: "#939b8f",
    fillOpacity: 0.761
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v1h-1v-1z",
    fill: "#8c938e"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22h1v1h-1z",
    fill: "#a0afac"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22v1h-1v-1z",
    fill: "#cee0d4"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-1h1v1z",
    fill: "#f8fffd"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h1v1h-1z",
    fill: "#c3cfbf"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v-1h1v1z",
    fill: "#a5b1a4"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v1h-1v-1z",
    fill: "#e5f1ed"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22h1v1h-1z",
    fill: "#9ea994"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23v-1h1v1z",
    fill: "#e5ebe7"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22h1v1h-1z",
    fill: "#c4cebe"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v-1h1v1z",
    fill: "#cad7cd"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23h-1v-1h1z",
    fill: "#cfdbc8"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22h1v1h-1z",
    fill: "#adb4aa"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22h1v1h-1z",
    fill: "#a5af9f"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h-1v-1h1z",
    fill: "#909386"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22v1h-1v-1z",
    fill: "#888882"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#7b7f73"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23v-1h1v1z",
    fill: "#707c6e"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23h-1v-1h1z",
    fill: "#8d9688"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#99a198"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22h1v1h-1z",
    fill: "#b0b8b4"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-1v-1h1z",
    fill: "#cbd2cc"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1z",
    fill: "#ccd4c9"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1z",
    fill: "#858f83"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#72776d"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1z",
    fill: "#626259"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#5c6452"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#778178"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#7a8787"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#68706d"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#525d6b"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#32466b"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#0f233b"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#09152b"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#0f1424"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#1a1f44"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1z",
    fill: "#445fac"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#3d65d3"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#6278af"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#9fafb8"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#c2d5e9"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#c8d4e8",
    fillOpacity: 0.443
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1z",
    fill: "#d9d3c0",
    fillOpacity: 0.161
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1z",
    fill: "#dac5a1",
    fillOpacity: 0.965
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v-1h1v1z",
    fill: "#e4c792"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1z",
    fill: "#d09a44"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#eecf6a"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M88 23h-1v-1h1z",
    fill: "#fefbd6"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#faf6d4"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22v1h-1v-1z",
    fill: "#d0bb5e"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1z",
    fill: "#e3ce86"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v-1h1v1z",
    fill: "#e4c476"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M93 22v1h-1v-1z",
    fill: "#e6c57c"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v-1h1v1z",
    fill: "#b68b42"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23v-1h1v1z",
    fill: "#7c5922"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23h-1v-1h1z",
    fill: "#6d4f22"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23v-1h1v1z",
    fill: "#7f6430"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22h1v1h-1z",
    fill: "#876d38"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22v1h-1v-1z",
    fill: "#746232"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M100 23h-1v-1h1z",
    fill: "#b4aa65"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M101 22v1h-1v-1z",
    fill: "#eee9b5",
    fillOpacity: 0.655
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23v1h-1v-1z",
    fill: "#909490",
    fillOpacity: 0.235
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h-1v-1h1z",
    fill: "#838880",
    fillOpacity: 0.961
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23v1h-1v-1z",
    fill: "#a0a89d"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23h1v1h-1z",
    fill: "#acbaaa"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23h1v1h-1z",
    fill: "#c5d2c1"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v1h-1v-1z",
    fill: "#f1faec"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h1v1z",
    fill: "#b0bfa7"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24h-1v-1h1z",
    fill: "#e9f5f3"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#b6c8b4"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1z",
    fill: "#bdc7bd"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v1h-1v-1z",
    fill: "#b8c2b0"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#a2afa3"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-1v-1h1z",
    fill: "#8c937e"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#7a8270"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1z",
    fill: "#707b6b"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1z",
    fill: "#6f7972"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h1v1h-1z",
    fill: "#78867a"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23h1v1h-1z",
    fill: "#748275"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1z",
    fill: "#5c6864"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1z",
    fill: "#556461"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1z",
    fill: "#60768c"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1z",
    fill: "#8b9cb6"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1z",
    fill: "#adb0aa"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1z",
    fill: "#a6b0a5"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-1z",
    fill: "#7f8d80"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1z",
    fill: "#788077"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#72746b"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#6e7470"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#666c61"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#757f7e"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#333f4e"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#0f224e"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#0e215e"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#061931"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#0b1127"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#15183a"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#314598"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#3470de"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#2b5ece"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#7690b6"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#4a5d88"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#6c9bdb"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#b9defa",
    fillOpacity: 0.404
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1z",
    fill: "#d7c5a0",
    fillOpacity: 0.761
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1z",
    fill: "#e3c996"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M85 23h1v1h-1z",
    fill: "#b3813c"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#d3b258"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h1v1h-1z",
    fill: "#fef8b4"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#d2c17a"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24h-1v-1h1z",
    fill: "#d2b85b"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1z",
    fill: "#f9f4bb"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M91 24v-1h1v1z",
    fill: "#eed893"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v1h-1v-1z",
    fill: "#bc9e5e"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23h1v1h-1z",
    fill: "#a27e38"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23h1v1h-1z",
    fill: "#856125"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h-1v-1h1z",
    fill: "#84652b"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M97 24h-1v-1h1z",
    fill: "#95763c"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M98 23v1h-1v-1z",
    fill: "#836638"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M99 24h-1v-1h1z",
    fill: "#695a36"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M99 23h1v1h-1z",
    fill: "#9b955c"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M101 23v1h-1v-1z",
    fill: "#f0ebb9",
    fillOpacity: 0.416
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25v-1h1v1z",
    fill: "#979d9d",
    fillOpacity: 0.443
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h1v1h-1z",
    fill: "#747e70"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24h1v1h-1z",
    fill: "#616c59"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25h-1v-1h1z",
    fill: "#747d6b"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25h-1v-1h1z",
    fill: "#99a38e"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24h1v1h-1z",
    fill: "#93a08a"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24v1h-1v-1z",
    fill: "#cbd2c8"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25h-1v-1h1z",
    fill: "#bed0bb"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#a7ada5"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#94998d"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#979f99"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#6a7065"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1z",
    fill: "#626e65"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1z",
    fill: "#616c69"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1z",
    fill: "#8a9699"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#8c9a9d"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#6f7f89"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#415a90"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1z",
    fill: "#264eaa"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1z",
    fill: "#2c5ecf"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1z",
    fill: "#5776bf"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#8e9395"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#9fa69c"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#838e86"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#68766d"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#63706f"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#586a7d"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#394e5d"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#1c2e39"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#0c162e"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#071329"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#0b102a"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#101634"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#1c2856"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#1d347e"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#133988"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#2348a0"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#526aa3"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#8195cd"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#5385df",
    fillOpacity: 0.996
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#8ab8e6",
    fillOpacity: 0.282
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h-1v-1h1z",
    fill: "#cdbe92",
    fillOpacity: 0.608
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M85 24v1h-1v-1z",
    fill: "#d2b687"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#846027"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1z",
    fill: "#aea050"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#f5edab"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1z",
    fill: "#9c8137"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24v1h-1v-1z",
    fill: "#c6b668"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#faf5bc"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#d3b46c"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#a27b3d"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24v1h-1v-1z",
    fill: "#96712c"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M95 24v1h-1v-1z",
    fill: "#865e20"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M95 25v-1h1v1z",
    fill: "#937438"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h1v1h-1z",
    fill: "#816633"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25v-1h1v1z",
    fill: "#7b5c25"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M98 24h1v1h-1z",
    fill: "#887643"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M100 24v1h-1v-1z",
    fill: "#aaa471",
    fillOpacity: 0.957
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M100 24h1v1h-1z",
    fill: "#f8f8ce",
    fillOpacity: 0.145
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25v1h-1v-1z",
    fill: "#8c9385",
    fillOpacity: 0.576
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25v1h-1v-1z",
    fill: "#5f685d"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25h1v1h-1z",
    fill: "#5f6b5e"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25v1h-1v-1z",
    fill: "#727d6d"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v-1h1v1z",
    fill: "#717663"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25h1v1h-1z",
    fill: "#787c6c"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26v-1h1v1z",
    fill: "#697662"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#5e6858"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#646d5e"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#4a5244"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#484f4d"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1z",
    fill: "#81888b"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1z",
    fill: "#9ea0a1"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1z",
    fill: "#8090a3"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#3d598d"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1z",
    fill: "#1f3978"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#0f358a"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#124ac7"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1z",
    fill: "#2c65eb"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M47 26h-1v-1h1z",
    fill: "#466fbd"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26h-1v-1h1z",
    fill: "#8fa3b6"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1z",
    fill: "#95a09f"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#879493"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26h-1v-1h1z",
    fill: "#708289"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-1v-1h1z",
    fill: "#495b6a"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1z",
    fill: "#122842"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#0a1a2c"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#091126"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#090e25"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#0b102c"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#091232"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#192848"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#737f97"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#616d8e"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#516081"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#7e8ea4"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#abb3b5"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#c0cddb"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#89a0c8",
    fillOpacity: 0.812
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#6d6db6",
    fillOpacity: 0.027
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1z",
    fill: "#b9b9a2",
    fillOpacity: 0.043
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1z",
    fill: "#9f9b74",
    fillOpacity: 0.231
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1z",
    fill: "#9b9065",
    fillOpacity: 0.514
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#826d3f",
    fillOpacity: 0.792
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1z",
    fill: "#836d3b",
    fillOpacity: 0.965
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#a88959"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M85 25h1v1h-1z",
    fill: "#7e6025"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h1v1h-1z",
    fill: "#d3cd82"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#fbfad1"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#ccba74"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#d1bf5c"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M90 25h1v1h-1z",
    fill: "#edde92"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1z",
    fill: "#c7a25a"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1z",
    fill: "#a7792f"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26h-1v-1h1z",
    fill: "#a3762d"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26h-1v-1h1z",
    fill: "#9d7431"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M96 25v1h-1v-1z",
    fill: "#8e6a2f"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26v-1h1v1z",
    fill: "#664820"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25h1v1h-1z",
    fill: "#6d4b1d"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M99 26h-1v-1h1z",
    fill: "#847642"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26h-1v-1h1z",
    fill: "#bfba8e",
    fillOpacity: 0.584
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v-1h1v1z",
    fill: "#3f3f3f",
    fillOpacity: 0.016
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27h-1v-1h1z",
    fill: "#808377",
    fillOpacity: 0.592
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27h-1v-1h1z",
    fill: "#797d73"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v1h-1v-1z",
    fill: "#5c6254"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27h-1v-1h1z",
    fill: "#464a39"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h1v1z",
    fill: "#707568"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h-1v-1h1z",
    fill: "#4a5849"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#57675b"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#576155"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26v1h-1v-1z",
    fill: "#7e877f"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#8a8e87"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27v-1h1v1z",
    fill: "#999d9c"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#7186c0"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#163c92"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#07265c"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#04235e"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1z",
    fill: "#1247b8"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#2d66eb"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#3e63bb"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#788ead"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#98aeb5"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#5b7782"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-1h1v1z",
    fill: "#586f7c"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#32414c"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#172536"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#0b1b32"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#091530"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#0c1536"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#0a1544"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#0c1949"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#05193b"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#304059"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#9ca49e"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#9ea99d"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#a3aaa3"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#abb0aa"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#bcc4c2"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#dee5ee"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#bbc7cd",
    fillOpacity: 0.871
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#bcc",
    fillOpacity: 0.059
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#8d7155",
    fillOpacity: 0.035
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#88824e",
    fillOpacity: 0.345
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1z",
    fill: "#898552",
    fillOpacity: 0.631
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1z",
    fill: "#9c8754",
    fillOpacity: 0.851
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#746441",
    fillOpacity: 0.992
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#6e5e45"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#684820"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27v-1h1v1z",
    fill: "#57380e"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26h1v1h-1z",
    fill: "#7b5c2d"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26v1h-1v-1z",
    fill: "#6e4f1e"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1z",
    fill: "#b7a54f"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26h1v1h-1z",
    fill: "#fefbb7"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h1z",
    fill: "#f4e6a2"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26h1v1h-1z",
    fill: "#e3c35d"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#e6cb74"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#cca55c"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#ae8131"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M93 26h1v1h-1z",
    fill: "#ab7922"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26v1h-1v-1z",
    fill: "#dbc479"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M96 27h-1v-1h1z",
    fill: "#b99c5c"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26h1v1h-1z",
    fill: "#866340"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M98 27h-1v-1h1z",
    fill: "#684921"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M98 26h1v1h-1z",
    fill: "#8d8251",
    fillOpacity: 0.949
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26v1h-1v-1z",
    fill: "#ceceac",
    fillOpacity: 0.145
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28v-1h1v1z",
    fill: "#9e9e9e",
    fillOpacity: 0.475
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h-1v-1h1z",
    fill: "#a5a6a0",
    fillOpacity: 0.851
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1z",
    fill: "#5f6159",
    fillOpacity: 0.941
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v1h-1v-1z",
    fill: "#585d51",
    fillOpacity: 0.847
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#7a7c72",
    fillOpacity: 0.745
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#546053",
    fillOpacity: 0.78
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1z",
    fill: "#505e51",
    fillOpacity: 0.992
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#485146"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28v-1h1v1z",
    fill: "#3c4b44"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h1v1h-1z",
    fill: "#596559"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27v1h-1v-1z",
    fill: "#888f8e"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#728cc5"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#0b3587"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#07235b"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#0b204c"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#083182"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#265edf"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1z",
    fill: "#3154b3"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#203f7e"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#486cae"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#5f85aa"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#4b636d"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#363b49"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#262b44"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#111f43"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#1e326a"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#162a6c"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#0b1d5f"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#091d51"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#0c1e3e"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#363f54"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#878b84"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#a6aca6"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#a4acaa"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#a9b0aa"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#ced8d0"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#f4fcf9"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#cbd4d1"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#bac9c3",
    fillOpacity: 0.337
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#b1b1a4",
    fillOpacity: 0.231
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#d5cf9b",
    fillOpacity: 0.773
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#ab9865"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1z",
    fill: "#7d6533"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28h-1v-1h1z",
    fill: "#9e8455"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1z",
    fill: "#6a4e24"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1z",
    fill: "#563d24"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28v-1h1v1z",
    fill: "#5a3d17"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#85682a"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M85 28h-1v-1h1z",
    fill: "#937139"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h-1v-1h1z",
    fill: "#654517"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h-1v-1h1z",
    fill: "#836425"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#bba454"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1z",
    fill: "#eac96d"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#e6ac42"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#dca340"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#c89c4a"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1z",
    fill: "#a7843b"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1z",
    fill: "#b38c3e"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28v-1h1v1z",
    fill: "#c5a956"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M95 27h1v1h-1z",
    fill: "#c0a259"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28v-1h1v1z",
    fill: "#8d6c3c"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M97 27h1v1h-1z",
    fill: "#8c7440"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M99 27v1h-1v-1z",
    fill: "#b9ad75",
    fillOpacity: 0.863
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h-1v-1h1z",
    fill: "#9c9c9c",
    fillOpacity: 0.051
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#9c9c94",
    fillOpacity: 0.122
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1z",
    fill: "#5c5c5c",
    fillOpacity: 0.043
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#6c736c",
    fillOpacity: 0.129
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#5e6659",
    fillOpacity: 0.953
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#3c4b43"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#596771"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#7f8678"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#4c649b"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#092d81"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#052050"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#09183b"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#052159"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#224ec8"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#344fb6"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#041e65"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#092a93"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#21448f"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#365076"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#717a8e"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#686b85"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#424968"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#33467f"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#0c2560"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#0a2159"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#0a2556"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#0d1d45"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#2d3a62"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#898e90"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#98a7b1"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#979f9c"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#a7afa5"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#d8ded6"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#e8efe6"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#bfc6bf"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#bdc3c2",
    fillOpacity: 0.592
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#ffc",
    fillOpacity: 0.02
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#a4a6a6",
    fillOpacity: 0.506
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#8ba4ce",
    fillOpacity: 0.965
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1z",
    fill: "#e1eee3"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#e6d9a4"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M79 28v1h-1v-1z",
    fill: "#b09557"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29v-1h1v1z",
    fill: "#b8965a"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#956d2f"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#926b36"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h1v1h-1z",
    fill: "#6a4c1f"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28h1v1h-1z",
    fill: "#81632b"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v-1h1v1z",
    fill: "#947233"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28v1h-1v-1z",
    fill: "#8d6b39"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#876c36"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#765f26"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#bc944e"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#c98623"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#c29139"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#b79a54"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#b3994c"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1z",
    fill: "#ddbd77"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29h-1v-1h1z",
    fill: "#986a27"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M95 28h1v1h-1z",
    fill: "#af843a"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28h1v1h-1z",
    fill: "#97773c"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M98 28v1h-1v-1z",
    fill: "#a68b4e"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v1h-1v-1z",
    fill: "#c7b575",
    fillOpacity: 0.773
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#6b7166",
    fillOpacity: 0.176
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#6d7269",
    fillOpacity: 0.984
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#58665d"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#a3aeae"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#8d8f78"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#4e5354"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#0e2f74"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#072f7f"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#071c4c"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#0a112c"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#091843"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#173699"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#2a4eba"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#041d64"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#07237c"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#042584"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#122f89"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#485c96"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#57636f"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#4c5763"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#1f3562"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#031e53"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#0f215c"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#17265a"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#143491"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#2660d0"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#6a7075"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#6e899a"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#546c76"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#878c86"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#e1e6e3"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#e9efe8"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#939c94"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#b1b5b4",
    fillOpacity: 0.682
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#8890b2",
    fillOpacity: 0.118
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#5665a7",
    fillOpacity: 0.682
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#9399d0"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1z",
    fill: "#bdbfe2"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#7788b3"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#666265"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#746150"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1z",
    fill: "#756b62"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#d5bb8b"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1z",
    fill: "#a28149"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#5f3e18"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v1h-1v-1z",
    fill: "#5e3b11"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29v1h-1v-1z",
    fill: "#7a5a23"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#9d7e43"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1z",
    fill: "#76602e"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#69552e"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#8b763a"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#b18342"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30h-1v-1h1z",
    fill: "#9f7335"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1z",
    fill: "#8d7533"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#b99543"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29h1v1h-1z",
    fill: "#d2ba68"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29v1h-1v-1z",
    fill: "#ae874d"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M96 30h-1v-1h1z",
    fill: "#a67024"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M96 29h1v1h-1z",
    fill: "#c59b46"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1z",
    fill: "#c7b06f",
    fillOpacity: 0.992
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M99 30h-1v-1h1z",
    fill: "#e4d0a7",
    fillOpacity: 0.412
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#66694f",
    fillOpacity: 0.314
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#7d8279"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#717d75"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#959993"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#27395b"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1z",
    fill: "#0a226f"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#0b2a77"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#061f4b"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#0f1541"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#0f1e54"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#0c2875"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#274eb3"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#072368"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#24459b"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#1c44b8"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#0f37a6"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#0f2e86"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#314468"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#293a69"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#091948"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#0a1846"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#1c2c6a"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#264095"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#11319d"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#4d8fdb"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#788288"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1z",
    fill: "#7a7a5f"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1z",
    fill: "#6a6e6e"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#a3aca9"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#f4fcf8"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#f8fefb"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#b2bcb4"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#c2c8ca",
    fillOpacity: 0.682
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#6f7eb7",
    fillOpacity: 0.349
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#4456a1",
    fillOpacity: 0.878
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#3959cf"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#4966e3"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#767bbc"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#5a5989"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#4d517f"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#54536b"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1z",
    fill: "#4e4c61"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#4d4f62"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#35344f"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#3e333e"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1z",
    fill: "#64533c"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1z",
    fill: "#988045"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30v1h-1v-1z",
    fill: "#b4934e"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#9f7f49"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#6d5333"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#8d774f"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#bd9e6c"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#b69458"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1z",
    fill: "#cea359"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#debd79"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#e7d596"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30h1v1h-1z",
    fill: "#c8a363"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M95 30h1v1h-1z",
    fill: "#956621"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M96 31v-1h1v1z",
    fill: "#c79e3d"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1z",
    fill: "#f0e59a",
    fillOpacity: 0.855
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h1v1h-1z",
    fill: "#ffe2ff",
    fillOpacity: 0.035
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#87897d",
    fillOpacity: 0.604
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#949c8e"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1z",
    fill: "#747f73"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#6d7169"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#757b85"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#394f7f"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#09206c"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#09235f"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#0b1f55"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#162977"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#0d2e85"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#0a2879"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#1f42a5"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#13307c"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#718dca"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#6e8ddb"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#1540af"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#0d35a9"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#15449c"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#19449c"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#03174a"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#0c1a4d"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#2f51aa"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#1b48d0"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#1a3eb5"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#4b668e"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#6a6d63"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#847b5d"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#6c6f5a"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#929e8f"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#d7e7d4"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#e2ede1"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#eef6ed"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#eff7f9",
    fillOpacity: 0.706
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#afcfff",
    fillOpacity: 0.063
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#566ab4",
    fillOpacity: 0.58
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#3d50ae"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#2c409e"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#2848b4"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#2d48b5"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#374597"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#202f62"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#314a90"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1z",
    fill: "#243880"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#312d45"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1z",
    fill: "#3b2f3b"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v1h-1z",
    fill: "#232253"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v1h-1z",
    fill: "#182678"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32v-1h1v1z",
    fill: "#1a2a81"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32h-1v-1h1z",
    fill: "#323064"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-1h1z",
    fill: "#5e5549"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M87 32h-1v-1h1z",
    fill: "#8a7544"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#826235"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1z",
    fill: "#927244"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#d3b67e"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#be9f71"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#6f5d56"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#85776e"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32v-1h1v1z",
    fill: "#c0a88d"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1z",
    fill: "#e0d6a5"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1z",
    fill: "#b7975b"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32h-1v-1h1z",
    fill: "#cda338"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v1z",
    fill: "#f6ec92",
    fillOpacity: 0.925
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M99 31v1h-1v-1z",
    fill: "#f6f6c1",
    fillOpacity: 0.114
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#a09797",
    fillOpacity: 0.106
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#959793",
    fillOpacity: 0.922
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#848d81"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#6c786a"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#656d6f"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#63738d"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#7c8fa7"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#132e6b"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#0a1b50"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#08194a"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#0f2566"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#0f2d82"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#162f80"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#3858a8"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#133493"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#6a96ef"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#90aae7"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#3166e3"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#1e4cd2"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#072e7f"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#062467"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#0e2050"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#1a337a"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#3563de"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#0e44e3"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#0d3db0"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#3e589c"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#636a7e"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#7a776d"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#787150"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#757e67"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#aab7a7"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#9ba69a"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#c6cfcb"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#c9d6cc",
    fillOpacity: 0.769
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#798bbc",
    fillOpacity: 0.165
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#2d499f",
    fillOpacity: 0.776
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#2239a9"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#192781"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#252e6d"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#203269"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-1v-1z",
    fill: "#1d2d5f"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#0f1745"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#0b1539"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1z",
    fill: "#031138"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#0b1a54"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v1h-1v-1z",
    fill: "#0f1d5d"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h-1v-1h1z",
    fill: "#161e44"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32h1v1h-1z",
    fill: "#1f1e3b"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1z",
    fill: "#2c3255"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32h1v1h-1z",
    fill: "#42476d"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32v1h-1v-1z",
    fill: "#383d7e"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h-1v-1h1z",
    fill: "#262757"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1z",
    fill: "#1e2025"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#2f251c"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1z",
    fill: "#5c4522"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v-1h1v1z",
    fill: "#a38647"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1z",
    fill: "#95785c"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#3a4171"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h-1v-1h1z",
    fill: "#6675c2"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#6c86d8"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33v-1h1v1z",
    fill: "#a2a2ba"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32v1h-1v-1z",
    fill: "#caa662"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v-1h1v1z",
    fill: "#d5a539"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33h-1v-1h1z",
    fill: "#f3e778"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M98 32h1v1h-1z",
    fill: "#f7f5ab",
    fillOpacity: 0.42
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#808986",
    fillOpacity: 0.365
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#797d7d"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#3d4f5b"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#22345b"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#5d7396"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#7a91a1"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#3f5273"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#0a1841"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#061a43"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#071b43"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#05194d"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#3b5183"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#7186a5"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#1844bb"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#4479f7"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#96aeed"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#5881e2"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#0e2e95"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#04114b"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#0d1659"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#2a345f"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#1937a8"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#0e2998"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#05238e"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#062aa3"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#234096"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#4e6ab7"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#596d8c"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#74756d"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#636655"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#71776c"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#6c736c"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#a1a9a7"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#b2beb4",
    fillOpacity: 0.98
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#5d72b9",
    fillOpacity: 0.937
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#132692"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#16278f"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#0c226c"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#2e3f74"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#6573a8"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#48558a"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#152156"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#111e51"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#101e54"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#112260"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h1z",
    fill: "#1a2b72"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#122255"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#0c1835"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#0b1934"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1z",
    fill: "#1c203a"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33h1v1h-1z",
    fill: "#262a57"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33v1h-1v-1z",
    fill: "#3c3865"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#332b32"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#2d2520"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#261b1a"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h-1v-1h1z",
    fill: "#53412a"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#594329"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1z",
    fill: "#31375a"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1z",
    fill: "#3766eb"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#67a0fa"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M95 33v1h-1v-1z",
    fill: "#96a0e1"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v1h-1v-1z",
    fill: "#c9a464"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33h1v1h-1z",
    fill: "#ca9c39"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33v1h-1v-1z",
    fill: "#c3b256"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M98 34v-1h1v1z",
    fill: "#f0eda7",
    fillOpacity: 0.741
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#788282",
    fillOpacity: 0.6
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#8190a8"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#46577d"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#1d2b56"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#061e55"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#51698b"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#82929f"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#748389"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#112040"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#061945"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#071a45"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#07194c"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#345aa0"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#4d62a4"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#2d5cda"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#457fec"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#819ddb"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#4666ac"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#021767"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#030e3e"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#071349"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#16276b"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#06217d"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#021050"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#071e8b"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#133abf"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#4565ca"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#4c70c3"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#657bb3"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#8799b5"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#9ca29e"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#a7aba9"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#999f9c"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#8b918b"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1z",
    fill: "#5667b3"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#2036a4"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#1f309f"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#24358a"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#445895"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#4865a4"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#293878"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#13205c"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#131e5a"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#181f5c"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#151e5a"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M79 34h1v1h-1z",
    fill: "#1a2263"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1z",
    fill: "#1e2564"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34v1h-1v-1z",
    fill: "#141740"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h-1v-1h1z",
    fill: "#13143a"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1z",
    fill: "#10143f"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M85 35v-1h1v1z",
    fill: "#11195c"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35h-1v-1h1z",
    fill: "#191b4f"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#21192f"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M88 34h1v1h-1z",
    fill: "#2a2024"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35h-1v-1h1z",
    fill: "#221f26"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#18161e"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35h-1v-1h1z",
    fill: "#19263f"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v-1h1v1z",
    fill: "#325cce"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#5289f9"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35h-1v-1h1z",
    fill: "#90aef1"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35h-1v-1h1z",
    fill: "#e4d1a8"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M97 35h-1v-1h1z",
    fill: "#b78639"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h-1v-1h1z",
    fill: "#b09f4d"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M99 34v1h-1v-1z",
    fill: "#e1dfa3",
    fillOpacity: 0.925
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M99 35v-1h1v1z",
    fill: "#fffff4",
    fillOpacity: 0.098
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#55556a",
    fillOpacity: 0.047
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#4f5d8d",
    fillOpacity: 0.847
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#4c618d"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#59697a"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#182a50"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#0b1e57"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#07245c"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#31446b"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#5b7083"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#2a446c"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#021a49"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#091940"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#0a1851"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#1e44a6"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#405897"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#1f43b1"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#2f5be1"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#7e9ee1"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#4364a9"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#031257"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#030e37"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#060e40"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#12266e"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#294388"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#15238d"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#1e389c"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#2146b7"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#4a6fd7"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#5a78c3"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#5b7ed0"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#7a95b8"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#c1c8c2"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#c5ced0"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#bec3c6"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#bec3c1"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#aab1b0"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#8f9ab9"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1z",
    fill: "#3e57c0"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#697bce"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#7c93d6"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#768fcd"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#333f88"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#161d60"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#162265"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#122268"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#16246d"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#15246c"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1z",
    fill: "#1e2973"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#262e7b"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1z",
    fill: "#222e7a"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#1e2f75"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M83 35h1v1h-1z",
    fill: "#212772"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h1v1h-1z",
    fill: "#1f225e"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M86 35v1h-1v-1z",
    fill: "#141d47"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#0e173a"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1z",
    fill: "#0e1131"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36h-1v-1h1z",
    fill: "#0e1437"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#0e1637"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#16162d"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M91 36v-1h1v1z",
    fill: "#1c262e"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v1z",
    fill: "#1e317a"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1z",
    fill: "#325dd7"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36v-1h1v1z",
    fill: "#6f97f0"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35v1h-1v-1z",
    fill: "#c2bfbc"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M96 36v-1h1v1z",
    fill: "#c39052"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35v1h-1v-1z",
    fill: "#9f8942"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h1v1h-1z",
    fill: "#e3e5a1",
    fillOpacity: 0.992
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36v-1h1v1z",
    fill: "#ffffd5",
    fillOpacity: 0.192
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#364167",
    fillOpacity: 0.184
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#3e4979",
    fillOpacity: 0.988
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#4e5e6d"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#334560"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#0a2759"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#091e58"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#071a50"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#213360"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#7d8ba5"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#667c9d"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#27395c"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#2b3343"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#16295d"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#2b69cc"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#4069ae"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#233e95"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#0c3abd"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#4169c0"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#3e5897"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#040c3e"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#02061d"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#030622"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#263f81"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#4663ab"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#1b2d8d"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#3055b9"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#4368c1"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#4f70c2"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#5c76ac"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#5c81bc"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#6c87c6"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#929fa2"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#d0d8d7"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#d3dbdb"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#d6dee1"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#acbada"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#b2bbe2"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#96a9d4"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#5e6fb9"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#21337e"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#172a78"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#172c83"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#162e86"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#142a7d"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#11266a"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36h1v1h-1z",
    fill: "#121f5f"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#141d4a"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#0e1a44"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#0d1e46"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v1h-1v-1z",
    fill: "#141f50"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M85 36v1h-1v-1z",
    fill: "#1b205a"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#201e56"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#0e193b"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1z",
    fill: "#111730"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-1h1v1z",
    fill: "#131730"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1z",
    fill: "#151d32"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1z",
    fill: "#192333"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#2e3a3d"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#1c285a"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1z",
    fill: "#2047a6"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M95 36v1h-1v-1z",
    fill: "#6195ee"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37h-1v-1h1z",
    fill: "#959adb"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36v1h-1v-1z",
    fill: "#b6886a"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37v-1h1v1z",
    fill: "#6f5438"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M98 36h1v1h-1z",
    fill: "#998e4a"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36h1v1h-1z",
    fill: "#d7d78f",
    fillOpacity: 0.278
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#404455",
    fillOpacity: 0.294
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1z",
    fill: "#4d566e"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#6d7384"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#959cab"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#707d8e"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#122654"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#091d59"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#213780"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#60769c"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#7990a6"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#4a5b70"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#1f284a"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#13286c"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#448fda"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#62a8e6"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#39509d"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#072797"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#2e49a2"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#2c4681"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#040e35"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#030513"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#020418"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#1c3996"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#436dc6"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#142d9f"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#052199"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#122f93"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#526aae"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#5f739f"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#5c7191"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#6479a7"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#6d82a5"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#9ea8a5"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#cedbd5"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#d5dfdf"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#d9e2df"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#dae6e5"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#e3e4e6"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#d9e1e0"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#bdc6ca"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1z",
    fill: "#b9bdc9"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#aeb4ca"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#96a2bf"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#6977a4"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#54659e"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#3d4f89"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1z",
    fill: "#1c2e6b"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1z",
    fill: "#111d61"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37h1v1h-1z",
    fill: "#151f58"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38v-1h1v1z",
    fill: "#0f183e"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1z",
    fill: "#0f1632"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#0f1438"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#0e143e"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v1h-1v-1z",
    fill: "#112168"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38v-1h1v1z",
    fill: "#162186"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M88 38v-1h1v1z",
    fill: "#1d1f51"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#343d3b"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1z",
    fill: "#485457"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#1e2d53"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1z",
    fill: "#1d3a8e"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38v-1h1v1z",
    fill: "#6aa3f0"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37h1v1h-1z",
    fill: "#8a92d6"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38v-1h1v1z",
    fill: "#9a796b"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37h1v1h-1z",
    fill: "#765634"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M98 38v-1h1v1z",
    fill: "#907337"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M99 38v-1h1v1z",
    fill: "#c0b769",
    fillOpacity: 0.322
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#373a55",
    fillOpacity: 0.361
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#585c75"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#768092"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#4f6384"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#72829b"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#3b4c84"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#182b84"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#34509b"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#476899"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#6b8298"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#3f4b58"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#0c1b46"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#092779"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1z",
    fill: "#60a8e5"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1z",
    fill: "#71c5fb"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#1d4ab3"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#071d7d"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#2d4184"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#243771"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#000b2d"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#020617"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#030519"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#0f226a"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#446bd4"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#1748de"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#133fcb"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#4668c0"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#4661a6"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#566786"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#575c62"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#536581"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#5c71b2"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#6f81a8"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#b2bbbb"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#a5aaa9"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#a1a7a7"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#b1bab3"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#cfd7d6"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1z",
    fill: "#ccd1d1"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#ccd5d2"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#e1e8e8"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#dcdee2"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#c4c7cc"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#c4cacd"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#bcc4c8"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M79 38v1h-1v-1z",
    fill: "#9c9daa"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1z",
    fill: "#75778e"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v1h-1v-1z",
    fill: "#43476a"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38h1v1h-1z",
    fill: "#101639"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#1f2139"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1z",
    fill: "#181a32"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#0f1635"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1z",
    fill: "#0f1633"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M86 39v-1h1v1z",
    fill: "#0f173f"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38h1v1h-1z",
    fill: "#172798"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v-1h1v1z",
    fill: "#1e327f"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#313537"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#424646"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1z",
    fill: "#585c5f"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#323347"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h1v1h-1z",
    fill: "#21397b"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h1v1h-1z",
    fill: "#619cea"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M96 39h-1v-1h1z",
    fill: "#6989dd"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38h1v1h-1z",
    fill: "#6e6596"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v-1h1v1z",
    fill: "#a48057"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M98 39v-1h1v1z",
    fill: "#d1a24c"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M100 39h-1v-1h1z",
    fill: "#d5cd78",
    fillOpacity: 0.341
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#254271",
    fillOpacity: 0.424
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#62769c"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#647186"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#627396"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1z",
    fill: "#7a8aa3"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#6e81a8"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#324d9b"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#1946af"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#2247a5"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#34497a"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1z",
    fill: "#253148"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#263651"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40v-1h1v1z",
    fill: "#0a328d"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#71c0f2"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40h-1v-1h1z",
    fill: "#6fccff"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#1451d7"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#092286"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#273b77"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#202a61"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#02061e"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#010712"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#06071d"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#070b3a"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#081f7a"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#1055de"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#5d94f4"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#7fa4e4"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#6481c8"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#4b639b"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#6c6d67"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#5a6264"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#495989"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#596f9c"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#747c7f"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#7b857f"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#697472"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#5a6666"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#677c79"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#a4adaa"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#c6ccc9"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#cfded4"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#edf7ef"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#bfbec5"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#7f827f"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#80867c"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1z",
    fill: "#a6a8a1"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h-1v-1h1z",
    fill: "#b3bcb2"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#aab3b5"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#6f7588"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#41485f"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#313756"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1z",
    fill: "#263150"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39h1v1h-1z",
    fill: "#17254c"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#141c47"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v1h-1v-1z",
    fill: "#131a38"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1z",
    fill: "#2f3942"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1z",
    fill: "#383e3e"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-1z",
    fill: "#484a46"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h1v1h-1z",
    fill: "#595b5b"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1z",
    fill: "#443a33"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M93 40v-1h1v1z",
    fill: "#393e69"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1z",
    fill: "#4f85e0"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40h-1v-1h1z",
    fill: "#638ae8"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v1h-1v-1z",
    fill: "#738af4"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h-1v-1h1z",
    fill: "#a690be"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M99 39v1h-1v-1z",
    fill: "#9c7c6f"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M100 40h-1v-1h1z",
    fill: "#91a07f",
    fillOpacity: 0.337
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#45619f",
    fillOpacity: 0.49
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#355e98"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#637c9c"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#677194"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#40508b"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#93a7c2"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#97aac7"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1z",
    fill: "#6988c0"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#3d5faf"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#182e68"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#0f143b"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#21315a"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#0d3f9c"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#7ed8f9"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h1v1h-1z",
    fill: "#71dbfe"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#256cf3"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#0c33b2"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#182e87"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#1d2d67"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#060b1d"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#010516"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#060921"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#090d3c"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#050d41"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#08298f"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#76ace9"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#9abfe9"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#77a8e3"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#4663a5"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#5b6674"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#5e6b61"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#525d75"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#54637c"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#57655f"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#7f8f87"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#79847e"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#576d68"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#5a6c6b"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#596968"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#758987"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#a0aeab"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#e0ece9"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#ecf7f3"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#dcd9e0"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#847e74"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#b2b6b1"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#929ba0"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#54565d"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#515754"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h1v1h-1z",
    fill: "#6e796f"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#94989b"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#6e7391"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1z",
    fill: "#394b86"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-1z",
    fill: "#1a2b6a"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M86 41v-1h1v1z",
    fill: "#1a1d47"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M87 41v-1h1v1z",
    fill: "#2a2b34"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40h1v1h-1z",
    fill: "#494d49"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#3a3e39"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#38433c"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#434c4d"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#434340"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-1z",
    fill: "#44476c"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#3d70d4"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40v1h-1v-1z",
    fill: "#668de6"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M96 41v-1h1v1z",
    fill: "#7e94f6"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M97 40h1v1h-1z",
    fill: "#556fed"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h1v1h-1z",
    fill: "#3243a8"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M99 40h1v1h-1z",
    fill: "#748fa7",
    fillOpacity: 0.412
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#6474a3",
    fillOpacity: 0.525
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#36509d"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#69769c"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#5d6d91"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#8590b2"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#7187a4"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#113a86"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#496ab3"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#4165bb"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#374883"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#333542"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#25355e"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#286abd"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#3c93de"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#256ac8"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#2264ea"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#1856e0"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#092d9a"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#112555"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#040918"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#03051b"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#090a24"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#060b2e"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#030f2b"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#061045"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#18367e"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#354f99"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#3558a3"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#4060ab"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#59668a"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#575d67"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#4f6882"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#627899"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#606e74"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#6c7670"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#667270"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#59706e"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#5c7271"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#556e6c"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#4a6562"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#495b5a"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#a7b3b1"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#dfebe3"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#eff0f2"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#908a95"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#6a726a"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#abb0b0"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#908c96"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#797881"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#7b8185"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#a7aeac"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#c1c7c7"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#b2b9ce"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#3c4271"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#252639"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1z",
    fill: "#3f3f3c"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#3c3e3c"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#393a34"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#383e39"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#323838"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#424141"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#414e75"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#3365c8"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-1h1v1z",
    fill: "#839eee"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#8e9fee"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#4d75f8"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M99 42h-1v-1h1z",
    fill: "#5764b2"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v1h-1v-1z",
    fill: "#93a1a4",
    fillOpacity: 0.522
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#828394",
    fillOpacity: 0.592
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#4d659c"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#2e4a8a"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#697b9a"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#627a9b"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#576f99"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#5772aa"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#1d56bb"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#1c62e5"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#1f459d"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#33394d"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#123680"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#3a84d8"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#093aac"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#103fc4"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#134ddf"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#2464f7"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#113ba4"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#091e63"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#03061f"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#030818"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#050a28"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#040925"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#040a2f"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#060d35"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#0b194e"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#1f368d"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#3c5291"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#545f7b"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#6b7a8e"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#697071"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#526687"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#65779d"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#515f6f"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#52635f"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#647a7d"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#5f777a"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#567475"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1z",
    fill: "#54706d"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#516967"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#3d5050"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#5a6663"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#aab4b0"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#bbc1bc"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#c8cbcf"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#838d98"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#aeb4b0"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#bdbfbb"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1z",
    fill: "#b9bcbd"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1z",
    fill: "#b5bdbf"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M83 43h-1v-1h1z",
    fill: "#c6ced3"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1z",
    fill: "#e0e8e6"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43h-1v-1h1z",
    fill: "#f9fcfc"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#a7a7be"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v-1h1v1z",
    fill: "#2d2c3f"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M88 43h-1v-1h1z",
    fill: "#353431"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42h1v1h-1z",
    fill: "#343332"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#3a3b35"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#3b3a40"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#3e3f46"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#3f4642"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#68698a"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#2e54b4"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#809df0"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#bdbff2"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42h1v1h-1z",
    fill: "#6785f7"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h-1v-1h1z",
    fill: "#3959ca"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v-1h1v1z",
    fill: "#5e7ca7",
    fillOpacity: 0.58
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#717b99",
    fillOpacity: 0.671
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#4f6ba7"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#22418c"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#33538e"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#6b83b0"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#becdd8"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#a9bfe7"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#70b5fa"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#4da8ff"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#224ca7"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#2b355b"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#5c8ac3"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#3b7ccb"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#16389b"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#1c4fc5"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#1e60d9"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#1a53d2"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#0e318c"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#0f1e6e"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#0c0e37"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#01081c"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#081337"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#030a2b"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#02092a"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#040d3b"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#051641"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#34508f"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#616b80"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#5f5e58"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#79848c"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#7f8893"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#525c6d"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#6676a0"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#68758c"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#5f7172"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#7b8a89"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#7a8e8c"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#627577"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#576761"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#6e7b7c"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#798484"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#6e776e"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#727b75"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#7c807f"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#9da3a3"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#b0bcc7"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#8f9aba"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#8089a9"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#727a95"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#576981"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#616e8f"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#717d9c"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#6b787b"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#606c6e"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#2b3139"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#30312d"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#3f3e39"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#3c3b36"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#3b3f45"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#42484d"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#2e3b31"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#6c6160"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#3e56a8"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#7c9ff6"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#c5c8f1"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#8896f1"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#3653cf"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h1v1h-1z",
    fill: "#5a77bc",
    fillOpacity: 0.643
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#5b70ae",
    fillOpacity: 0.729
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#4168c0"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#2a45a3"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#4c619d"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#96a2bd"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#4168ba"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#2d6eeb"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#7cdeff"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#4ea1ef"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#0b2b7d"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#545f85"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#edf9fb"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#8196a4"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#68748c"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#7692bb"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#aac8eb"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#90a2b4"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#32417a"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#03165c"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#13358c"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#06133a"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#0a1345"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#060c33"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#080a39"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#030c39"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#314571"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#687685"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#67664d"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#626351"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#60727d"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#496c9b"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#656b7d"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#536b93"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#828d9b"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#6c7d7c"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#778180"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45h-1v-1h1z",
    fill: "#a6b0ab"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#929798"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#4b4f4d"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#63656a"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#858886"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#6a6e65"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#6b6c5d"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#727064"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#9ca5a1"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#a1a9b4"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#727ea5"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#4a5f9a"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#415292"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#2c3c87"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#293985"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#2c3c6f"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#28353e"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#2c3231"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#2d322f"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#2b2e30"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1z",
    fill: "#3a3a37"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#48453c"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#3b3b2d"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#3e3f35"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1z",
    fill: "#343b36"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#464659"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#495fb1"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#89a3f7"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#bcc6ed"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#999ce2"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#4867d2"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#7e9be2",
    fillOpacity: 0.725
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#5668a8",
    fillOpacity: 0.773
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#4e6cca"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#3455b0"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#264291"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#1d4ca3"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#3587e5"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#77d4fd"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#a0fcff"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#4e9ce2"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#092162"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#8e9cb2"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#cdd8ca"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#818e8c"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#8d95a4"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#b2c5d0"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#bfcec8"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#969983"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#516085"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#34458c"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#486dc2"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#102461"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#091550"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#020d3d"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#060e48"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#334375"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#556578"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#6b685b"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#6b664d"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#726d60"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#5e6b6b"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#4d658d"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#677693"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#5b7194"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#8b929a"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#757c84"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#7f8789"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#999896"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#535555"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#393e3f"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#646b69"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#676d74"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#67706d"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#626862"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#879082"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#c7cecd"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#9fa6be"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#243267"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#303c79"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#203076"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#2a3764"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#363e4c"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#2f373a"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#303030"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#2e2f30"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h-1v-1h1z",
    fill: "#2c2f29"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1z",
    fill: "#2c2e29"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#36372e"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#3c3c2d"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1z",
    fill: "#444639"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#3b413b"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#455670"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#6986d5"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#89a5f5"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#aebbee"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#9599eb"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#5a73e3"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#7e9ad9",
    fillOpacity: 0.769
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#4f63a1",
    fillOpacity: 0.643
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#546fd0"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#3051a9"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#2c53a8"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#75b2ec"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#bbfdff"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#bafffd"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#a2f3fe"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#3973ab"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#212b50"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#949db0"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#7e8989"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#7a8086"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#a0abb6"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#b8c4d0"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#949799"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#7e796f"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#747c8e"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#8c928e"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#b2c0b5"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#304377"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#031e6b"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#09298f"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#2f4695"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#737d92"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#808e8a"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#848d86"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#76766c"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#656451"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#62696f"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#5a636f"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#546c92"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#66778c"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#6d6c67"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#70757b"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#898e92"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#79786f"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#a69f90"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#6f6965"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#454b49"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#414744"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#767b80"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#6e7474"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#647167"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#636f6d"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#a3a8ab"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#bac1ca"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#354067"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#394875"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#354259"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#394552"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#363d48"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#2c3030"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#2e2d28"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#2b2e2b"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46v1h-1v-1z",
    fill: "#282e2a"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#292c28"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#2a2e25"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#2c2f28"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#333a31"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#363934"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#496685"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1z",
    fill: "#6d9ef2"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1z",
    fill: "#879df3"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#a9b3ef"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#99a3f0"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#8094f6"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46v1h-1v-1z",
    fill: "#617ec2",
    fillOpacity: 0.678
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#5c6ea4",
    fillOpacity: 0.596
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#506ec6"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#425a94"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#747f96"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#e0f0f4"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#eef9f5"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#99b4b4"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#626a74"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#676b60"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#98a3aa"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#868f98"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#9ca8b9"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#cfe1e6"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#bbcdca"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#8c8983"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#8c7e73"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#aaadb1"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#a1a9a0"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#9eb5af"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#344b8a"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#113bbb"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#153bb5"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#677389"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#7a7c64"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#b8beb6"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#adb5b8"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#7c8082"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#777d79"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#5c6570"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#5f6262"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#576a86"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#4e69a7"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#4a505c"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#444e61"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#646f84"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#6a716d"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#857c69"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#938472"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#515149"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#474d47"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#676e6e"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#69716e"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#5d6d67"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#546362"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#717976"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#8688a8"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#3e4767"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#414e57"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#495972"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#515f8a"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#363e46"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#30302c"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1z",
    fill: "#2b2c28"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M88 48h-1v-1h1z",
    fill: "#272b2a"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1z",
    fill: "#2a2b29"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#2a2a29"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#252830"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#2f2e32"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-1z",
    fill: "#313030"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#537486"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#5f8bf2"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#8099f2"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#a6b3ed"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#9eabf3"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#95a5ff"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48h-1v-1h1z",
    fill: "#8199da",
    fillOpacity: 0.541
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#5a689e",
    fillOpacity: 0.651
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#637aaf"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#748180"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#6f6d5f"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#a5aebd"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#cdd6d8"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#a4aea2"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#868680"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#7e7e6f"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#959ca6"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#8a9ea9"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#a6b4c5"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#e1eae3"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#959e93"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#807b74"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#89877b"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#9aa2b2"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#4a5a69"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#2e3870"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#263579"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#334b78"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#828375"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#96916d"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#888671"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#96998e"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#878e87"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#92999a"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#75828a"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#6e716d"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#57626d"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#536fa0"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#596785"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#5f6870"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#5d6471"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#5b5c65"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#5b524b"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1z",
    fill: "#9d8d7a"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#7d6f62"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#44463d"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#606b60"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#666d68"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#586765"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#4d5d57"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#717c73"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#717d78"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#8e8e96"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#363b40"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#545f67"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#5d6c84"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#57688d"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#43568c"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#3a405b"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1z",
    fill: "#2e313c"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48h1v1h-1z",
    fill: "#232f2e"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v-1h1v1z",
    fill: "#222e2b"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#242b2b"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#272c33"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1z",
    fill: "#2a322f"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#37435d"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#3d66da"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#869df4"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-1z",
    fill: "#a1aef1"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M97 49v-1h1v1z",
    fill: "#9ea7f0"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1z",
    fill: "#aab0ef"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48v1h-1v-1z",
    fill: "#afbce5",
    fillOpacity: 0.314
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#636e89",
    fillOpacity: 0.573
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#8d9796"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#575d49"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#616150"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#81909b"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#b0bfc8"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#8f8f82"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#7f8282"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#8d9897"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#5f5d5a"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#abaeb2"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#abb6b7"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#95a4a7"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#b0bcaf"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#a4aaa8"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#919693"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#8e938e"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#b1b2b0"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#9da8a2"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#646d7c"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#515b88"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#506285"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#5a6d89"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#8a8975"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#828070"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#7a7460"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#6f6c54"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#6e7365"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#7a7e77"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#718096"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#5f6a7f"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#626455"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#556366"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#717f89"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#c1c4c2"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#a7abae"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#8c9195"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#433b37"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1z",
    fill: "#a58c7e"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#af9585"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#453e35"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#3e4534"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#5f6355"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#5a6159"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#69736a"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#70786f"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#6e7170"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#444945"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#575e61"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#556064"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#677289"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#5d79a8"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#4f639a"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1z",
    fill: "#354278"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50v-1h1v1z",
    fill: "#2c3953"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#2e3844"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1z",
    fill: "#282d35"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1z",
    fill: "#2a2a31"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#282d33"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#282f2f"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#2e353c"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#5775bc"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#89a0fb"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#9fabf5"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#a9adef"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#c5c2d4",
    fillOpacity: 0.941
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50h-1v-1h1z",
    fill: "#dbdbca",
    fillOpacity: 0.114
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#a4a8ac",
    fillOpacity: 0.231
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#c9cdd0",
    fillOpacity: 0.976
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#969a8f"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#80878e"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#b8c4ce"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#d0d4cd"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#737262"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#8c9490"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#5d686c"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#a4a9b0"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#afb8b6"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#9da49b"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#a5acab"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#9b9fa0"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#aaaeb0"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#aab1b1"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#aabbc5"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#abb5c5"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#7f8ea2"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#657285"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#5c6571"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#5f6660"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#6e7468"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#848267"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#787b61"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#7a7b77"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#6a6d61"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#727d7b"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#6f6c5c"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#5c6870"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#738492"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#bcc0bc"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#767d7e"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#6b7373"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1z",
    fill: "#484a3e"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#947a68"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#cdb19e"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#5e5047"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#282b22"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#384233"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#4d503f"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#4f4f45"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#434a42"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#5b6159"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#575f56"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#535e59"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#525b5c"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#576671"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#667489"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#657499"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#5a70a1"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#394fa4"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h1v1h-1z",
    fill: "#2e4480"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51v-1h1v1z",
    fill: "#2e3e5b"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#2e3945"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#2f353d"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#2b2f36"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1z",
    fill: "#2b2d2d"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#2e2e2b"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#5f6a8e"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#93a7f9"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#96a7f2"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1z",
    fill: "#a0aef4"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#bec0de",
    fillOpacity: 0.773
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51h-1v-1h1z",
    fill: "#ffa",
    fillOpacity: 0.012
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#979ca0",
    fillOpacity: 0.435
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#bfc3c4",
    fillOpacity: 0.996
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#969887"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1z",
    fill: "#95a1a7"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#a0a6a7"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#7b7a65"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#6f7366"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#7b8686"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#a0a8b0"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#c1cac5"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#b2bbb9"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#98a1a5"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#a0afb8"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#afb4a9"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#a1a49f"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#aebaba"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#a6a4a7"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#b1ab9f"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#a3a091"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#787974"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#737475"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#555f52"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#64685e"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#757866"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#686e5a"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#777b7d"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#6e7374"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#646c79"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#656c69"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#636f73"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#828993"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#6c7895"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1z",
    fill: "#787f79"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#72756e"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#747b7c"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#636a68"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#8e8579"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#b0a49a"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#746d65"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#5c5e59"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#666b6a"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#787873"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#8f8f8a"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#75797a"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#5f6967"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#525a5a"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#4d575b"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#4b596b"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#586c84"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#48588a"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#405b8a"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#455a8b"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M88 52h-1v-1h1z",
    fill: "#3e507c"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-1z",
    fill: "#354961"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1z",
    fill: "#303b4d"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#343a42"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#32343e"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1z",
    fill: "#29323a"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1z",
    fill: "#2a2e2e"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#5c6a97"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#9aaef8"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#a1b2f0"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#c1bfe5"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1z",
    fill: "#c7c7dc",
    fillOpacity: 0.545
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#6c6f66",
    fillOpacity: 0.545
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#a3a7a6",
    fillOpacity: 0.996
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#939790"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#a0aaac"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#888e88"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#81816c"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#888d8a"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#d9e1e6"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#aeb3a7"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#b2babc"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#becad2"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#a8b4c0"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#c4ccb4"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#a6a89e"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#979995"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#635e53"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#8e8a76"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1z",
    fill: "#a4947e"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#9f9a90"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#757f7f"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#6e7161"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "#5e6553"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#757b6f"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#565a55"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#636c70"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#7c8387"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#7280a2"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#77828e"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#717c89"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#767c86"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#7a7f89"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#798184"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#7f8483"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#6d7679"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#5f7270"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#7b8784"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#7a8382"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#65695c"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#707168"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#565a56"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#636568"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#4d5455"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1z",
    fill: "#434d4a"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#444849"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#444c49"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#4f5b5e"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#424f66"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#535c67"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#707b92"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#576880"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#404d60"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#424e57"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1z",
    fill: "#495559"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1z",
    fill: "#4a4f59"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#434753"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#383e4a"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53v-1h1v1z",
    fill: "#303742"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#2c3743"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1z",
    fill: "#5170ba"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#8aa5f9"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#a7b3ec"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#b3b8e2"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M99 52v1h-1v-1z",
    fill: "#ccd6da",
    fillOpacity: 0.298
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fillOpacity: 0.016
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#a4a6aa",
    fillOpacity: 0.737
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#cdd2d4"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#8e9587"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#7b806e"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#6e6f5c"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#9a9995"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#eef6f9"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#b9bcad"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#9b9ea3"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#b3bdc0"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#aeb2b0"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#abaca3"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#acaea7"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#9c978c"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#afa599"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#b9bcb2"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#7f7a69"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#908b83"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#777d72"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#86857a"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#767b6b"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#8b958f"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#707b8d"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#737a8e"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#6e797c"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#77899b"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#96a2a4"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#98a19f"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54h-1v-1h1z",
    fill: "#8f9088"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#6c694e"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#727363"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#75807f"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#70857e"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#7e8e8b"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#75705d"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#5c635b"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#515d5d"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#39413b"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#323536"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#373e3c"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1z",
    fill: "#46534e"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#444f4b"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#3e4842"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#495554"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#4e5f78"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#3d4956"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#3e474e"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#505964"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#4a515e"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#485459"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#475457"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#414c4d"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#3f474e"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#384149"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1z",
    fill: "#383e44"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#3b404c"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#3b62bc"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1z",
    fill: "#7f9bf4"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1z",
    fill: "#aab2f0"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#bab8d9",
    fillOpacity: 0.906
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53v1h-1v-1z",
    fill: "#e6f2da",
    fillOpacity: 0.082
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#babdc0",
    fillOpacity: 0.322
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#b1b8b9",
    fillOpacity: 0.969
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#b5bdc1"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#b7bebc"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#838b7d"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#656659"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#8c8884"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#d9dfe0"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#a3a797"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#989a95"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#a7afba"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#b2b9be"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#8e9186"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#8a8c81"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1z",
    fill: "#c8cbc1"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1z",
    fill: "#b0b7a8"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#8f9589"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#77786d"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#7c7d74"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#8b8a84"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#959793"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#a8acab"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#919494"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#777d7c"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#606f84"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#9aa3a7"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#9ba89e"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54h1v1h-1z",
    fill: "#979c98"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#868c8e"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#7a7a74"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#757563"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#9da59f"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1z",
    fill: "#a4a691"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#b4a686"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#b99f76"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#a08059"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M73 54v1h-1v-1z",
    fill: "#856f50"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#474b42"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#353e41"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#333c3a"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#34393c"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#455553"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#40504f"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#394642"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#3f4e4f"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#516682"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#677388"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#394249"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#293042"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#2c3241"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1z",
    fill: "#363e49"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#3e4951"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#39444a"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h-1v-1h1z",
    fill: "#384148"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#343e46"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54h1v1h-1z",
    fill: "#3f4648"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#3b444c"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#7486a3"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#90a1ea"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#9eb1f7"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M97 55v-1h1v1z",
    fill: "#babfe7",
    fillOpacity: 0.69
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#9fa29c",
    fillOpacity: 0.325
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#a2a3a1",
    fillOpacity: 0.953
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#9ca09b"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#929994"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#8b8e99"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#aeabb7"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#d5d8dc"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#b1b5b2"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#908e8b"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#babfbd"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#b5b8b7"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#818271"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#8a8c84"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#929987"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1z",
    fill: "#777865"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#6e6e5c"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#656654"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#80817c"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#8e928f"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#919896"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#9fa4a8"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#7382a6"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#7586ac"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#a0aca2"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#9e9e9a"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#707978"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#72878c"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1z",
    fill: "#898983"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#897f66"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1z",
    fill: "#866e38"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h1v1z",
    fill: "#d6a44c"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#b68537"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#81694b"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1z",
    fill: "#48453b"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#3e4144"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#393d40"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#313938"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#363e3f"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#2d3738"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#394545"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#3d464b"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#3b4243"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#3e4949"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#495b73"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#566479"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#5c6671"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#2d3740"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1z",
    fill: "#343b42"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1z",
    fill: "#2a3139"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#2d353f"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1z",
    fill: "#2e3441"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#2a3341"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#333e47"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#484d5a"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#303d50"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#7383ad"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-1v-1z",
    fill: "#babdd5"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#9eaef1"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#abb8ea",
    fillOpacity: 0.396
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#84877d",
    fillOpacity: 0.325
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#757d6a",
    fillOpacity: 0.976
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#727773"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#969baa"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#c6c7d3"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#dce1dd"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#7f7c6d"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#9c989d"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#ccd0d0"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#aab0a9"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#96989f"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#7f7f73"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1z",
    fill: "#76766a"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#757765"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1z",
    fill: "#7e867c"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#949c9d"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#adb8bc"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#8e9794"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#959b9c"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1z",
    fill: "#829ac7"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#8393b2"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#a2a8a1"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#a1a5a2"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#6b6f67"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#6d7064"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#a4a48e"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#a88e63"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#b48c42"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#b58d37"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1z",
    fill: "#be892b"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57h-1v-1h1z",
    fill: "#866c3f"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#4a4c3f"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#363f40"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#3e4043"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#333a37"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#313837"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#3a403d"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#39483f"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#39453f"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#3a4245"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#373d41"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#4c524b"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#465a6f"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#5c6774"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#414a4e"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#343b3e"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v1h-1v-1z",
    fill: "#293039"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56h1v1h-1z",
    fill: "#252d37"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#2a2d33"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#272e34"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#373f40"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#444c55"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#3b444d"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56v1h-1v-1z",
    fill: "#8491ae"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#919ae8"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#9aa9ea",
    fillOpacity: 0.949
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#97afef",
    fillOpacity: 0.125
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#929c8c",
    fillOpacity: 0.314
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#666d5c",
    fillOpacity: 0.71
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#7a7f7b",
    fillOpacity: 0.925
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#c0c3c8"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#c2c6c3"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#939593"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#83877b"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#9a9da1"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#cdcfcd"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#b2b3b3"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#b3b4ae"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#6f746e"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#8e9399"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#969a8d"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#8e9288"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#a8adac"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#9eaaae"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#838e9b"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#8a959f"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#adb1b2"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#babdba"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#b1c7d6"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#9baec1"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#a2a4a3"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#807d78"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#787154"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#988e62"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#968554"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#a89360"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#a49159"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#b89a5a"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#886a37"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#423e39"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#3b3f41"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#3b4142"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#3f4545"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#313937"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#2f3737"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#384240"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#4b544d"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#535e55"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#485554"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#404b46"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#595e60"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#596774"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#576989"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#4c556b"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#434b52"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#3c4246"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1z",
    fill: "#272e2f"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58v-1h1v1z",
    fill: "#2a2f2f"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#2e3335"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#303539"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#323b45"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#4b504f"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#d6c79f"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57v1h-1v-1z",
    fill: "#8a90c0"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#90a5e5",
    fillOpacity: 0.733
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#9e9e9e",
    fillOpacity: 0.114
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#afb2b2",
    fillOpacity: 0.365
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#989e97",
    fillOpacity: 0.859
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#9fa5a1"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#a7abab"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#d6d8cf"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#afae97"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1z",
    fill: "#b4b1b0"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#80847b"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#8e8d78"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#b5af99"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#949389"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#9c9c9c"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#b2b8b5"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#9ca19d"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#959b9a"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#bec7c4"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#cfdada"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#c3c9d7"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#b0a9ac"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#666657"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#929c80"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#c5cdb6"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#5b6b5a"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#525e58"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#576159"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#686f5b"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#484c4d"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#313c40"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#202d2e"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#303e3e"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#353f3d"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#313936"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#3b3e40"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#383b3e"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#384444"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#46544e"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#3a4649"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#495152"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#707074"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#60676d"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#4a5768"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#4b505c"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#505854"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58h1v1h-1z",
    fill: "#4c554c"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1z",
    fill: "#465047"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#454f46"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h-1v-1h1z",
    fill: "#474e47"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1z",
    fill: "#424b4b"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#414c50"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#374545"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#9b916b"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1z",
    fill: "#f6dda2"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#c8b996"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#abbacb",
    fillOpacity: 0.408
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#6a6a59",
    fillOpacity: 0.235
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#74766a",
    fillOpacity: 0.984
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#a1a3a2"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#a9adac"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#8b8d8d"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#9b9e93"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#a0a193"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#9b9b88"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#9ea18f"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#a0a19a"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#94938f"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#737263"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#7a7e72"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#adb0ac"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#b8bebe"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#a7adb0"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#cbd4d6"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#c1cbce"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#d9e0e1"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1z",
    fill: "#f2f4f4"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#9da8a1"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#d3e3dd"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#707e7e"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#3d4f53"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1z",
    fill: "#57656d"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#48585a"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#35494c"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1z",
    fill: "#313d41"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v1z",
    fill: "#233134"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#324245"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#536667"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#333f3f"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#333a38"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#303734"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#232d29"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#1f2d2a"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#2b3333"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#33393f"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#525655"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#69686b"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#545a57"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#4e5657"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1z",
    fill: "#525352"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M85 60v-1h1v1z",
    fill: "#525549"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#505648"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v-1h1v1z",
    fill: "#4f574c"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#535950"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#56594e"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#4b5250"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#434e51"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v-1h1v1z",
    fill: "#7a7b59"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#f4dd98"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#f7dc9e"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#e9d9a8",
    fillOpacity: 0.969
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#e6e0c8",
    fillOpacity: 0.165
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#5d5a48",
    fillOpacity: 0.608
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#878a8a"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#a2a8a3"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#7b8077"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#4d5a5b"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#838c87"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#a7ac9a"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#979898"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#93969e"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#959899"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#909691"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#8a908d"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#95a19e"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#9fa3a8"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#a7aeb3"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#b2b9c1"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#b5bec1"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1z",
    fill: "#e2e8ee"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#bac4c7"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#6c7879"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#353f41"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#6a7176"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#5f7176"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#54686f"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#3a4950"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#1d3132"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61h-1v-1h1z",
    fill: "#233c3c"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#768e8f"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#5d747b"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#2e403e"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#2d383b"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#2a3834"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#38483f"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#495350"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#454b48"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#3e403f"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#5a6058"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#60695e"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#4f5854"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#4d504b"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1z",
    fill: "#4d4f46"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h-1v-1h1z",
    fill: "#484c43"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#474f44"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61h-1v-1h1z",
    fill: "#565b53"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60h1v1h-1z",
    fill: "#595c4d"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61h-1v-1h1z",
    fill: "#566356"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h-1v-1h1z",
    fill: "#505c5d"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v1h-1v-1z",
    fill: "#585d66"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60h1v1h-1z",
    fill: "#c0b185"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#fde59b"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1z",
    fill: "#fceeb4"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#f2ecce",
    fillOpacity: 0.906
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#f2e5cc",
    fillOpacity: 0.078
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#877878",
    fillOpacity: 0.067
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#7b8082",
    fillOpacity: 0.792
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#8c928f"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#8c8e83"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#676d64"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#909392"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#a1a9a8"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#9da4a0"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#909a97"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#999fa5"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#9299a6"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#979fa7"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#9ba2a8"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#98a5ab"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#939ba5"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#939da1"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#a3acaa"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#9da6a6"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#b3b5be"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#9fa5a8"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#7a8282"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1z",
    fill: "#868e8d"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#909592"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#556667"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#586a70"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#49585e"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#263635"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#6e837a"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#c8d7d4"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#7f908f"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#343e43"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#373e3a"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#777f6a"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#898e7b"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#60685f"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#44534e"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#5e6360"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#575e5a"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#6a7267"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#595d56"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#4b4c46"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1z",
    fill: "#49493d"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#51544a"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1z",
    fill: "#4e5754"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61v1h-1v-1z",
    fill: "#535a5f"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M88 62v-1h1v1z",
    fill: "#555c59"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#556561"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#536063"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#4d5660"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61h1v1h-1z",
    fill: "#999273"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#f8e199"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#fffddf"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#f2e6d7",
    fillOpacity: 0.812
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#83838b",
    fillOpacity: 0.129
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#9ea098",
    fillOpacity: 0.769
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#848570"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#86827d"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#50503d"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#636459"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#727864"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#838680"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#778076"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#778278"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#6f766e"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#7b807c"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#8f948e"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#9da2a0"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#979c9e"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#999fa0"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#7c8581"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1z",
    fill: "#879293"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#97a4a2"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#a5b7b8"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#8599a2"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1z",
    fill: "#45555d"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#495655"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1z",
    fill: "#cad5d1"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#e0e5e5"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#859298"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#434d4f"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#929683"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#b0b29c"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#888b7e"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#727c77"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#727871"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#6c6d60"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#565e54"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#686d64"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#535953"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#3c4743"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#565a53"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#63645e"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#4b5051"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1z",
    fill: "#4f5960"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#4b5a6a"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63h-1v-1h1z",
    fill: "#516374"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#4a545d"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#3d4954"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M92 63v-1h1v1z",
    fill: "#66685f"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#e7d698"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#ffffe1"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v1h-1z",
    fill: "#ede1c3",
    fillOpacity: 0.671
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#ffffe7",
    fillOpacity: 0.043
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#929281",
    fillOpacity: 0.431
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#92948d",
    fillOpacity: 0.863
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#899082"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#707258"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#737a67"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#70746b"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#62604a"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h1z",
    fill: "#78795f"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#737a62"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#777863"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#707157"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#69674a"
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#64624a"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#727366"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#7c8384"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#989da4"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#889595"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#768680"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#879392"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#cad9d5"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#eaf4f5"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#92a5af"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1z",
    fill: "#4e6666"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1z",
    fill: "#a4baae"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#d7e6e4"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#a3b0aa"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1z",
    fill: "#7c9084"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#b3c2b1"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#d8d8d1"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#989b93"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#929c97"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#adb7b4"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#8f978e"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#5d6453"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#586155"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#61675c"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#555d52"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#505a55"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#4e5653"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#555d5a"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#4d5862"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#44526b"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M89 63h1v1h-1z",
    fill: "#425362"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1z",
    fill: "#3d4f4a"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#4d5956"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#565954"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#bab989"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#ffffcb"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#ebdfb9",
    fillOpacity: 0.416
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#c1c1b7",
    fillOpacity: 0.098
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#b6b8b8",
    fillOpacity: 0.624
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#a6a89e",
    fillOpacity: 0.988
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#969d94"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#869387"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#797c6b"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#737159"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#575a48"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#72785c"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#717054"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#6f6a4f"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#6c6c54"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#6f796f"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#798685"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#768281"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#949b9f"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#cedadd"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#909fa6"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#737f84"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#889e98"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#d3e2d8"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1z",
    fill: "#dae4df"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#bfcec3"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#cddecf"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#ebf3ea"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#bfbfb7"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#939a99"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#919592"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#8c908c"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#8e8d8c"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1z",
    fill: "#5d6454"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#5c5e51"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#5d6056"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#60695c"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#676c5f"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#4d4f4a"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#33383c"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#3e4a52"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#41505d"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#364552"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#404d53"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1z",
    fill: "#455449"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M91 65v-1h1v1z",
    fill: "#515e55"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#4c524c"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#acad80"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#f8eebd",
    fillOpacity: 0.976
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64h1v1h-1z",
    fill: "#e0dab6",
    fillOpacity: 0.165
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#a1aaa1",
    fillOpacity: 0.118
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#a0a6ab",
    fillOpacity: 0.961
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#afb7bb"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#b1bbba"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#b4bfb8"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#a4a99b"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#7a7e71"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#80837d"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#82867e"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#6b7261"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#6a6c58"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#6f6f57"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#727661"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#838b84"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1z",
    fill: "#7b8987"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#7e8a83"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#8e9897"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#7e8991"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#657e7f"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#b3c5bd"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#d2e3dc"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#e0eae6"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#e9f0ec"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#c0cdc9"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#dbe7de"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#bfc4c3"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#8d9392"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#7d8486"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#8c8682"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#757268"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#766b62"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#636354"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#5f615b"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#6a6e61"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1z",
    fill: "#636b57"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1z",
    fill: "#565b56"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65h1v1h-1z",
    fill: "#37363e"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1z",
    fill: "#41434a"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65h1v1h-1z",
    fill: "#404750"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#313d3c"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h1v1h-1z",
    fill: "#525850"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#56594b"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#3f4740"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#4f5649"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#d0c38e"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#e9d8a2",
    fillOpacity: 0.796
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#8a7f74",
    fillOpacity: 0.094
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#8c7762",
    fillOpacity: 0.192
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#8b7a57",
    fillOpacity: 0.286
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1z",
    fill: "#9c9e96",
    fillOpacity: 0.639
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#acbcc1"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#acbbbc"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#879395"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#a0a6ac"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#c0c3c5"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#b7b9b5"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#9ea294"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#9aa098"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#a0a6a0"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#8b8e88"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#6f7166"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#6f6f5d"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#9a9a85"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#929c9d"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#96a6a0"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#9aa2a1"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#9aa4a6"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#afbfba"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#fcfffd"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#e5edee"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#bfc9c7"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#c9dad7"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#d8e4e1"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#c0c4c4"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#8b8c93"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#747978"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#7c7f77"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#85857b"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#74776a"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#69675a"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#565d58"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#555c62"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#565d5c"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#65665c"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h-1v-1h1z",
    fill: "#5f6659"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M85 66v1h-1v-1z",
    fill: "#535853"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M86 67h-1v-1h1z",
    fill: "#384146"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67h-1v-1h1z",
    fill: "#444d52"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v1h-1v-1z",
    fill: "#404751"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v1h-1z",
    fill: "#3b4647"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h1v1h-1z",
    fill: "#525a4a"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M91 67h-1v-1h1z",
    fill: "#515443"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#5d5e41"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#b6ac7b"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66v1h-1v-1z",
    fill: "#f9e6ab"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#e5dbab",
    fillOpacity: 0.478
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#4d452e",
    fillOpacity: 0.259
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#695f3d",
    fillOpacity: 0.694
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#6c5e30",
    fillOpacity: 0.824
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#7e6b3f",
    fillOpacity: 0.918
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#806a3a",
    fillOpacity: 0.98
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#8a7750"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#c5c4c0"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#98a4a9"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#738282"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#7b8d87"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#afb7b8"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M54 67h1v1h-1z",
    fill: "#a9afb5"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#b5b8b9"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#a7aaa9"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#9ea097"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#9aa09c"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#949e9f"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#828f83"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#a6aba0"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#c0c5c6"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#c0cace"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#a6aeb3"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#9eaba8"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#f5fbfc"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#d3dbdc"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#c4ccc8"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#dce9ea"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#93969f"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#6c6e71"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#777671"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#8b897f"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#7f8274"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#696c62"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#5f6761"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#575d5e"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#60625b"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#686a5f"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67h1v1h-1z",
    fill: "#5d6157"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M84 68v-1h1v1z",
    fill: "#525450"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68h-1v-1h1z",
    fill: "#34393b"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67v1h-1v-1z",
    fill: "#484f50"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68h-1v-1h1z",
    fill: "#455255"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67h1v1h-1z",
    fill: "#475452"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M90 67v1h-1v-1z",
    fill: "#54564c"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h-1v-1h1z",
    fill: "#4f4a30"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#b9a969"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M93 67v1h-1v-1z",
    fill: "#fadda2"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#f1dbb1",
    fillOpacity: 0.949
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#f1f1d5",
    fillOpacity: 0.145
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#373722",
    fillOpacity: 0.345
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#544c2c",
    fillOpacity: 0.984
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#836e3a"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#91763f"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#977e48"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#7d7759"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#57656b"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#556464"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#a5b2b3"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#b8c2c2"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#97a2a7"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#89949b"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1z",
    fill: "#a2b2b8"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1z",
    fill: "#d0d9dd"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#e4eae8"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#b4bcb8"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#9ba4a0"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#9ba9ab"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#b5c3c6"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68v1h-1v-1z",
    fill: "#b6c0c6"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#afb9c1"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#98a5a7"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#9aa5a3"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1z",
    fill: "#b3beb8"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1z",
    fill: "#d5dfdc"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#dee4e3"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#aab4ad"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#c8d5cf"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#cfd8dd"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#989ca3"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#818886"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#737569"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#74716a"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#707167"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#737261"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#69695a"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#6a6a5f"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#6c7063"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#6c6f62"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#6e6b5a"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#676a53"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69h-1v-1h1z",
    fill: "#686a52"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h-1v-1h1z",
    fill: "#6f6d5e"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68v1h-1v-1z",
    fill: "#464a48"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M87 69h-1v-1h1z",
    fill: "#414c47"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68v1h-1v-1z",
    fill: "#455154"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69v-1h1v1z",
    fill: "#494c3d"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69h-1v-1h1z",
    fill: "#796d3e"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M91 69h-1v-1h1z",
    fill: "#b49b56"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h1v1h-1z",
    fill: "#ebcf88"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M93 69h-1v-1h1z",
    fill: "#fbdda3"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#f0ddb6",
    fillOpacity: 0.686
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#53472f",
    fillOpacity: 0.169
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#8e774d",
    fillOpacity: 0.773
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#ad935f"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1z",
    fill: "#8a7753"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#35372f"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#303d3d"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#96a1a6"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#a8b1b6"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#a2afb1"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69v1h-1v-1z",
    fill: "#b1c1c4"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#c7d7da"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#e1f3f4"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#fcffff"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#f7fbfb"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#b7c3ca"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#b4bdc3"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#b3bdbf"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#c7d1db"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1z",
    fill: "#a2abb5"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#8c989f"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#9baaab"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#a2b0ad"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#c9d5cf"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#e1eae8"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#d5dcdb"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#b4c2bf"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#c0cfd6"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#9a9fae"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1z",
    fill: "#929a9e"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#a3aea5"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#b8bfb7"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#898a86"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#7e837b"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#717565"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#626352"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#727564"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M80 69v1h-1v-1z",
    fill: "#767a6c"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#6c7361"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#61644d"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#696e5b"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M83 69h1v1h-1z",
    fill: "#797a63"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M84 70v-1h1v1z",
    fill: "#6a6555"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h1v1h-1z",
    fill: "#4b4d46"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70h-1v-1h1z",
    fill: "#4e554f"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70v-1h1v1z",
    fill: "#615d46"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69h1v1h-1z",
    fill: "#685a31"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69v1h-1v-1z",
    fill: "#a88e48"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70v-1h1v1z",
    fill: "#ecd38c"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v-1h1v1z",
    fill: "#e9d08f"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M92 70v-1h1v1z",
    fill: "#f7dea9"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#f4e7c2",
    fillOpacity: 0.298
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#a58769",
    fillOpacity: 0.067
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#938056",
    fillOpacity: 0.427
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1z",
    fill: "#32331e",
    fillOpacity: 0.839
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h1z",
    fill: "#151c13"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#41433d",
    fillOpacity: 0.682
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#8e9098",
    fillOpacity: 0.816
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#a5b2bd"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#cbdce5"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v1h-1v-1z",
    fill: "#e2f5f9"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#f2fcfd"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1z",
    fill: "#fbfffe"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1z",
    fill: "#e7f2f4"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#bac4c5"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#b0b8be"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#b3bcc6"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#adbac1"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#95a2a7"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#8a9697"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#93a1a0"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#a2afad"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#e2efe9"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#c8d4d1"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#bdc7cd"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#9298a6"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#80868f"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#849191"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#b3c0bd"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#b8bcc0"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#959595"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#818685"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#686c62"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#706f61"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#848170"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#727068"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#595d55"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#595e51"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#687065"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M83 71v-1h1v1z",
    fill: "#717769"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#5f605a"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M86 70v1h-1v-1z",
    fill: "#444"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71h-1v-1h1z",
    fill: "#837d5f"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M88 70v1h-1v-1z",
    fill: "#a1874a"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71h-1v-1h1z",
    fill: "#8f7b38"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M89 70h1v1h-1z",
    fill: "#dac37c"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v1h-1v-1z",
    fill: "#dfc185"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M91 71v-1h1v1z",
    fill: "#f9e4a6"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v1h-1v-1z",
    fill: "#f8e8bc",
    fillOpacity: 0.616
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M93 71v-1h1v1z",
    fill: "#ffffbf",
    fillOpacity: 0.016
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71v1h-1v-1z",
    fill: "#0b160b",
    fillOpacity: 0.09
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#261e17",
    fillOpacity: 0.259
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#777",
    fillOpacity: 0.059
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#8f959a",
    fillOpacity: 0.529
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1z",
    fill: "#b3bcc6",
    fillOpacity: 0.961
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#e7f1f9"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#f6fefd"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#fbfefd"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#f9fffe"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1z",
    fill: "#daebef"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#bac7c7"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#b8c1c4"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#acb5bd"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#bcc6cf"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#acbbc1"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#8e9b9b"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#95a39a"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#c5d2cb"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#eef6f1"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#ebf5f4"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#c6ced8"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#9298a1"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#7f8a89"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#6f7771"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#96a096"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#a7ada6"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#acb5b5"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1z",
    fill: "#87938d"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#73766e"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#656a5a"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#5d6057"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#6e6d60"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#65675d"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#575855"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#6c6c5e"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#787a66"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h-1v-1h1z",
    fill: "#6c715d"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72v-1h1v1z",
    fill: "#5e6154"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M85 71h1v1h-1z",
    fill: "#625940"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71v1h-1v-1z",
    fill: "#bda561"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M88 71v1h-1v-1z",
    fill: "#dbc17a"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72h-1v-1h1z",
    fill: "#eddd9b"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72v-1h1v1z",
    fill: "#e6ce98"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72h-1v-1h1z",
    fill: "#e1c988"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v1h-1v-1z",
    fill: "#f4e3ad",
    fillOpacity: 0.757
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h-1v-1h1z",
    fill: "#ecdada",
    fillOpacity: 0.055
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#817d89",
    fillOpacity: 0.239
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#a1a1b6",
    fillOpacity: 0.8
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#d2d7e6"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#f9fafe"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h1v1h-1z",
    fill: "#e3f1f4"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#bed0d0"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#c0cbcd"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#bfc8ce"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#bcc5c9"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#c8d6d5"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#deeae7"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#c6d0d2"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#f3f7f8"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#b8bec5"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#7b8286"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#919593"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#939f9d"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#8b958e"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#aab6a4"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#c3cec8"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#acb0b3"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#8a8d8b"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#7c7e69"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#6b6a5d"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#63655d"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#63665a"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#535c52"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#565a4e"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#938769"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#8b8465"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73h-1v-1h1z",
    fill: "#6a6e52"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h1v1h-1z",
    fill: "#706c50"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72v1h-1v-1z",
    fill: "#938345"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72h1v1h-1z",
    fill: "#e3d096"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M87 73v-1h1v1z",
    fill: "#f4e8b0"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M88 73v-1h1v1z",
    fill: "#fbecbf"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73v-1h1v1z",
    fill: "#f3d89b"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72v1h-1v-1z",
    fill: "#f1d9a2",
    fillOpacity: 0.929
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M92 72v1h-1v-1z",
    fill: "#f1e4c4",
    fillOpacity: 0.153
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#5b5b6d",
    fillOpacity: 0.055
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1z",
    fill: "#898ea3",
    fillOpacity: 0.525
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#b1b5c5",
    fillOpacity: 0.965
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#eaeef5"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1z",
    fill: "#f9ffff"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#d1e0e0"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#c2cbd0"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#c3cbcf"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#cad1d1"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#dde5e9"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#c4cbd6"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#8c9b9f"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#b7c3c2"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#c8cfd4"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#b0bbb5"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#a8afaa"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#94a09c"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#99a59e"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#d6dede"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#a6acba"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#8f8f93"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#868579"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#7c7c66"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#777260"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#6b7066"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#5e645b"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1z",
    fill: "#5e635b"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#717868"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#90846d"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#746e5b"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#6e6a54"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1z",
    fill: "#887646"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1z",
    fill: "#c4ae6d"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M86 74v-1h1v1z",
    fill: "#e6cd98"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h-1v-1h1z",
    fill: "#f5e2a9"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74v-1h1v1z",
    fill: "#fde4ac"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73h1v1h-1z",
    fill: "#fbe5a7",
    fillOpacity: 0.98
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74h-1v-1h1z",
    fill: "#f0dfaa",
    fillOpacity: 0.345
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#94949d",
    fillOpacity: 0.216
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#b0aebf",
    fillOpacity: 0.698
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#d4d3e4",
    fillOpacity: 0.965
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#ece9ed"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1z",
    fill: "#cbcfd4"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#c5ced2"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#cad2d8"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#a0abb5"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#8f9ba0"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#c1d2cb"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#f5f9f6"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#f9fbf6"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1z",
    fill: "#e0e8ea"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#aab4be"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#b5c0bf"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#9faca3"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#b2bab8"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#9ea4aa"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#8d928a"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#b7b9b4"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#737467"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#83826d"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#99967d"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#636b62"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#6f7763"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#7c7c70"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#808582"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#777a76"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#4f5950"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1z",
    fill: "#71684d"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-1z",
    fill: "#93813b"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#e5d89f"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M87 74v1h-1v-1z",
    fill: "#f3dba5"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75h-1v-1h1z",
    fill: "#f9dea6"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h1v1h-1z",
    fill: "#ffe4a8"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1z",
    fill: "#f6e2ae",
    fillOpacity: 0.675
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#a694a6",
    fillOpacity: 0.169
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1z",
    fill: "#cbb6a1",
    fillOpacity: 0.482
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#bab09f",
    fillOpacity: 0.859
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#cbd1d5"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#bfc9cb"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#9faaad"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#ced7d7"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#f8fcfb"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#fdfffc"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#d4dfdb"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#afc2c1"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#e1ece6"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M70 76h-1v-1h1z",
    fill: "#b4b8b2"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1z",
    fill: "#bac0c1"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#8c8e8d"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#9ca296"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#bcc2c3"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#70716d"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#938c78"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#928d7d"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#61665c"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#6d7364"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#676a5c"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#7f827b"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#898b84"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#837a63"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#a38c4d"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1z",
    fill: "#cdbc78"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#fce6bb"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h-1v-1h1z",
    fill: "#fbe1a8"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75v1h-1v-1z",
    fill: "#fde1a9"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76v-1h1v1z",
    fill: "#fce4ac"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M90 75v1h-1v-1z",
    fill: "#f8ebb7",
    fillOpacity: 0.306
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1z",
    fill: "#997f59",
    fillOpacity: 0.078
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#bdbdb9",
    fillOpacity: 0.49
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#dbdfe6",
    fillOpacity: 0.914
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#bac9d0"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#b3c0d3"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#dedff2"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#e6ebf3"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#fafcfd"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#ebedf0"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#cedae7"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#cad7e1"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1z",
    fill: "#bdc5c4"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1z",
    fill: "#878c8a"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1z",
    fill: "#706d6d"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#555858"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#6d7978"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#646d66"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#82836f"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#7a7a71"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#6f7672"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#686d72"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#5a6156"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#5d5e58"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#918971"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1z",
    fill: "#bb9c6e"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#c1aa64"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#f7eab5"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#fbe1b2"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#fde4a7"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77h-1v-1h1z",
    fill: "#ffe7b2"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#fae5b7",
    fillOpacity: 0.898
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#f1e4c9",
    fillOpacity: 0.075
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#c1b9c1",
    fillOpacity: 0.129
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#b4bac8",
    fillOpacity: 0.627
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#98a7b9",
    fillOpacity: 0.996
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-1v-1z",
    fill: "#96a4bc"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#9fa8c2"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#bbc0d9"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#bcc1d9"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#c2cbd9"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#dae3e6"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#d6dad5"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#84857e"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#535758"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#2c3230"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1z",
    fill: "#6e776f"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#6d756b"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#757c6b"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#8f9590"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1z",
    fill: "#8a9199"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#676873"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#727a71"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#55574e"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#aba06d"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#af8f5e"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1z",
    fill: "#b7a35f"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1z",
    fill: "#faf0c7"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78h-1v-1h1z",
    fill: "#f8e2b5"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78v-1h1v1z",
    fill: "#fde4ab"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1z",
    fill: "#ffe7b4"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#fae4b5",
    fillOpacity: 0.682
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#aeb4c1",
    fillOpacity: 0.537
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#9cabb5"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#8b9aa6"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79h-1v-1h1z",
    fill: "#80909d"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#93a2b4"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#b3c5d9"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#a8b2ca"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1z",
    fill: "#babccc"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#939998"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1z",
    fill: "#636966"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1z",
    fill: "#77807b"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78v1h-1v-1z",
    fill: "#80827f"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#979da0"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#a1aaad"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#898f8d"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#8d908a"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#585e54"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#b4995f"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1z",
    fill: "#977638"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M83 79v-1h1v1z",
    fill: "#d5c180"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1z",
    fill: "#f4dfae"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1z",
    fill: "#f6dea6"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1z",
    fill: "#f9dfb0"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78v1h-1v-1z",
    fill: "#ffebb8"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78h1v1h-1z",
    fill: "#fae7ba",
    fillOpacity: 0.467
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#a0a097",
    fillOpacity: 0.106
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#97a2a7",
    fillOpacity: 0.941
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#94a0a8"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#88969d"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80h-1v-1h1z",
    fill: "#80909b"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#8d9aa8"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#7a8791"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h-1v-1h1z",
    fill: "#727f83"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#6f7776"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#798173"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#71796a"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#4c5243"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#878680"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M75 79h1v1h-1z",
    fill: "#7e8276"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#90988d"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#c6d1cd"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#b5bdb9"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#828484"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#65665a"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#b08c4d"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#9d7c35"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#f4df9e"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#f0d99d"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79v1h-1v-1z",
    fill: "#fbe4ac"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v-1h1v1z",
    fill: "#fee1b1"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80h-1v-1h1z",
    fill: "#fae4b7",
    fillOpacity: 0.973
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h-1v-1h1z",
    fill: "#f4e9c8",
    fillOpacity: 0.184
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#999fa3",
    fillOpacity: 0.588
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#97a1a6"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#919c9e"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#8a979b"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#797f81"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#6c756b"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#5c6b5c"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#687366"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#b5bdb5"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#a3a596"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#5e5f4a"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#575249"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#7b7e77"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#797d6d"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#9ba29f"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#aaafb3"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#82888c"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#827764"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#b98e51"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#9d7d3c"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1z",
    fill: "#f8e2aa"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80h1v1h-1z",
    fill: "#e6cd92"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v1h-1v-1z",
    fill: "#f8e0aa"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80h1v1h-1z",
    fill: "#ffe6b4"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80v1h-1v-1z",
    fill: "#f6e2bb",
    fillOpacity: 0.561
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#8f8f82",
    fillOpacity: 0.161
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#a0aba3",
    fillOpacity: 0.965
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#b7c1bb"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#869088"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#6e766b"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1z",
    fill: "#778271"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#a7b2a8"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#969da4"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#868482"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#80816a"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#5b564a"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#646656"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#828477"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#82847e"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#a0a4a4"
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#808784"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#ad9a74"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#c79b58"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#8d7332"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1z",
    fill: "#f3dca5"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1z",
    fill: "#ead090"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82v-1h1v1z",
    fill: "#fce4a8"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M87 82h-1v-1h1z",
    fill: "#f8e0b1",
    fillOpacity: 0.922
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v1h-1v-1z",
    fill: "#f4eacc",
    fillOpacity: 0.098
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fillOpacity: 0.004
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#bcc2bc",
    fillOpacity: 0.69
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#c0c7c2"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#9aa197"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#8f958d"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#9aa99e"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#d5e2db"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#bac3d0"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#8c9499"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#848b84"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#6f766c"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#747668"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#6e7261"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#a3a8a0"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#949590"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#90938f"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#86867a"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#dec288"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#d2a856"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1z",
    fill: "#998342"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1z",
    fill: "#f2dba3"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h1v1h-1z",
    fill: "#fae1a5"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M86 82v1h-1v-1z",
    fill: "#ffedad"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M86 83v-1h1v1z",
    fill: "#f5e2b6",
    fillOpacity: 0.663
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#b1b4ad",
    fillOpacity: 0.282
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#bbc3c4"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#a4afab"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#b4c0bb"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#dee7eb"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#dee3ee"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#a2a9ae"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#bdc2b9"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#c1c3bd"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#6f7473"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#939390"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#a6a7a0"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#9d9f9a"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#b1a888"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#fde09d"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h1v1h-1z",
    fill: "#debc67"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83v1h-1v-1z",
    fill: "#a38e54"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1z",
    fill: "#ecd8a2"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h-1v-1h1z",
    fill: "#ffe5aa"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84h-1v-1h1z",
    fill: "#fee8b2"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M87 83v1h-1v-1z",
    fill: "#f3e1bb",
    fillOpacity: 0.341
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1z",
    fill: "#a2a2a2",
    fillOpacity: 0.043
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#9aa5a7",
    fillOpacity: 0.835
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#c2cfd1"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#c2ccda"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#f0f0f8"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#c3c5d1"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#b3bab6"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#8c8c93"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#6f777d"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1z",
    fill: "#5e6569"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1z",
    fill: "#6f7875"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#7f8a82"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#949790"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#93948d"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1z",
    fill: "#d3c597"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#ffe4a2"
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#f0d584"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#b79e5f"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84v1h-1v-1z",
    fill: "#edd89e"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85v-1h1v1z",
    fill: "#ffe6ad"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h1v1h-1z",
    fill: "#f8e1b1",
    fillOpacity: 0.89
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85v-1h1v1z",
    fill: "#f0f0c6",
    fillOpacity: 0.071
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1z",
    fill: "#cacaca",
    fillOpacity: 0.361
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#babcd7",
    fillOpacity: 0.957
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#e2eaf1"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#d3d6e1"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#969ba3"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#85929e"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#b1bac0"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1z",
    fill: "#8c8f85"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#767d6b"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85h1v1h-1z",
    fill: "#82866f"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-1z",
    fill: "#909383"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1z",
    fill: "#737d77"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#8d9291"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#989685"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#d3c287"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#fee5a5"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M81 86v-1h1v1z",
    fill: "#fbde94"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#d9b875"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M83 85h1v1h-1z",
    fill: "#eedba7"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#ffe9af"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v-1h1v1z",
    fill: "#f6e1b3",
    fillOpacity: 0.62
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#afa4b4",
    fillOpacity: 0.188
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-1z",
    fill: "#dbcde8",
    fillOpacity: 0.541
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#9396a8",
    fillOpacity: 0.835
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1z",
    fill: "#76888d"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#a0b2b3"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1z",
    fill: "#bcc7cb"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#abaea3"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#d2d7c2"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87h-1v-1h1z",
    fill: "#d6d1bc"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87v-1h1v1z",
    fill: "#d8c7a7"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87v-1h1v1z",
    fill: "#968b7d"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#82868a"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#a3a393"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1z",
    fill: "#d1c18b"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#fce6aa"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M82 86v1h-1v-1z",
    fill: "#fee6a7"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M83 87h-1v-1h1z",
    fill: "#eac78b"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87h-1v-1h1z",
    fill: "#ead19c"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1z",
    fill: "#fbe3ae",
    fillOpacity: 0.988
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86h1v1h-1z",
    fill: "#f7e7bf",
    fillOpacity: 0.251
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87v1h-1v-1z",
    fill: "#6d6d5b",
    fillOpacity: 0.055
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87h1v1h-1z",
    fill: "#97999f",
    fillOpacity: 0.494
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87v1h-1v-1z",
    fill: "#d4dbe5",
    fillOpacity: 0.98
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87h1v1h-1z",
    fill: "#cfd9e5"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1z",
    fill: "#eaefec"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1z",
    fill: "#e2e1e7"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88v-1h1v1z",
    fill: "#bcb0ad"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M75 88v-1h1v1z",
    fill: "#a08d79"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1z",
    fill: "#6c6353"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#899391"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#9ba5a0"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#bab3a1"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1z",
    fill: "#f5dfa7"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h-1v-1h1z",
    fill: "#fae1a6"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88h-1v-1h1z",
    fill: "#dbbc7d"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87v1h-1v-1z",
    fill: "#f1d595"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M85 87v1h-1v-1z",
    fill: "#f8e1ae",
    fillOpacity: 0.784
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89v-1h1v1z",
    fill: "#b4aecb",
    fillOpacity: 0.31
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#acb3c4",
    fillOpacity: 0.882
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#d5dce7"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h-1v-1h1z",
    fill: "#c0bfbd"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1z",
    fill: "#94887b"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88h1v1h-1z",
    fill: "#606862"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#94999f"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#a6a6a3"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#888e86"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89v-1h1v1z",
    fill: "#b2a58e"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88h1v1h-1z",
    fill: "#f3dba1"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h1v1h-1z",
    fill: "#d1b778"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h-1v-1h1z",
    fill: "#f4e0a4"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88v1h-1v-1z",
    fill: "#fae5b8",
    fillOpacity: 0.424
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M71 89h1v1h-1z",
    fill: "#706a70",
    fillOpacity: 0.169
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1z",
    fill: "#b6b9c0",
    fillOpacity: 0.831
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M73 89h1v1h-1z",
    fill: "#a9a8a6"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h1v1z",
    fill: "#6f6d5c"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89v1h-1v-1z",
    fill: "#6f7569"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v1h-1v-1z",
    fill: "#929a97"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#888b97"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M79 89v1h-1v-1z",
    fill: "#a6a9a4"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M79 90v-1h1v1z",
    fill: "#94a291"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89h1v1h-1z",
    fill: "#8a8e83"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#c9bc98"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90h-1v-1h1z",
    fill: "#f3de9e"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89v1h-1v-1z",
    fill: "#f6e1a8",
    fillOpacity: 0.859
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h1v1h-1z",
    fill: "#f0e1c3",
    fillOpacity: 0.067
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v-1h1v1z",
    fill: "#bbacb4",
    fillOpacity: 0.133
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91v-1h1v1z",
    fill: "#7b7b75",
    fillOpacity: 0.729
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91h-1v-1h1z",
    fill: "#646a5b"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1z",
    fill: "#898e94"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#7a8290"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1z",
    fill: "#7b8395"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#a7aea8"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#bcc0c0"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M80 91v-1h1v1z",
    fill: "#9a9d92"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#9e9f96"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1z",
    fill: "#f1e4b8"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91v-1h1v1z",
    fill: "#fce4b3",
    fillOpacity: 0.451
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h1v1h-1z",
    fillOpacity: 0.012
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1z",
    fill: "#86897c",
    fillOpacity: 0.306
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#979a99",
    fillOpacity: 0.725
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#899096",
    fillOpacity: 0.976
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#808ea3"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#a7aba7"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#d4d6d4"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M81 91v1h-1v-1z",
    fill: "#e2e7dd"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#c8ccc2"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v1z",
    fill: "#bab5a8",
    fillOpacity: 0.886
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91h1v1h-1z",
    fill: "#e9dfbf",
    fillOpacity: 0.094
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#aaa59b",
    fillOpacity: 0.2
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#91939c",
    fillOpacity: 0.467
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#9a9990",
    fillOpacity: 0.706
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#bbbeb7",
    fillOpacity: 0.816
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#dee2e2",
    fillOpacity: 0.765
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1z",
    fill: "#d0cecd",
    fillOpacity: 0.561
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1z",
    fill: "#adad9e",
    fillOpacity: 0.196
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweetWrapper);
export default __webpack_public_path__ + "static/media/sweet-wrapper.91589172cb45eb85c34e8229a08f8186.svg";
export { ForwardRef as ReactComponent };